function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useRef } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import Loader from "./../Loader/Loader";
import { useTable, useSortBy } from "react-table";
import { Dropdown, Card, Button, Table, Modal, Col, Row, Form, OverlayTrigger, Tooltip, Badge, Alert, Container } from "react-bootstrap";
import classNames from "classnames";
import "./RealTimeNotification.css";
import { Field, FieldArray, Form as FormikForm, Formik, getIn } from "formik";
import * as Yup from "yup";
import TimePicker from "rc-time-picker";
import { ADD_REAL_TIME_ALERT_NOTIFICATION_MUTATION, LIST_REAL_TIME_ALERT_NOTIFICATION_QUERY, EDIT_REAL_TIME_ALERT_NOTIFICATION_MUTATION, DELETE_REAL_TIME_ALERT_NOTIFICATION_MUTATION, UPDATE_ALERT_NOTIFICATION_STATUS_MUTATION, ALERT_RULE_HEADER_DETAILS_QUERY, ALERT_RULE_LOGS_QUERY, TEAM_DETAILS_FOR_USER_QUERY, MEMBER_LIST_FOR_ALERT_QUERY, REAL_TIME_ALERT_TIME_LIST_QUERY } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { MdDeleteForever, MdModeEdit, MdPerson, MdLogout, MdInfoOutline } from "react-icons/md";
import { BsBell, BsExclamationTriangle, BsClock, BsPeople, BsBarChart, BsPencil, BsTrash } from "react-icons/bs";
import { InputGroup } from "react-bootstrap";
import { BsSearch, BsCalendar } from "react-icons/bs";
import { BsPersonCircle, BsDisplay, BsEnvelope, BsSlack, BsExclamationCircle, BsCup } from "react-icons/bs";
import { HiDownload } from "react-icons/hi";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
import Popover from "react-bootstrap/Popover";
import { GoClock } from "react-icons/go";
import { FaRegCalendarAlt, FaUserTimes, FaDesktop, FaClock, FaEnvelope } from "react-icons/fa";
import Select from "react-select";
import { HiOutlineExclamationCircle, HiLogout, HiOutlineUser, HiOutlineEye } from "react-icons/hi";
import { ConsoleView } from "react-device-detect";
import { FaExclamationTriangle } from "react-icons/fa";
import { AiOutlineCheckCircle, AiOutlineBell } from "react-icons/ai";
import { IoIosHelpCircleOutline, IoMdAlert } from "react-icons/io";
var LIMIT = 10;
var offset = 0;
var alertSubmitSchema = Yup.object().shape(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  ruleName: Yup.string().required("Required").max(50, "Rule name cannot exceed 50 characters"),
  alertType: Yup.string().required("Required"),
  sendEmailAt: Yup.string().required("Required"),
  expectedClockInTime: Yup.string().required("Required"),
  activeDays: Yup.array().min(1, "Please select at least one day.")
}, "sendEmailAt", Yup.string().when("alertType", {
  is: function is(val) {
    return val !== "high-idle-time" && val !== "early-clock-out-email-alert";
  },
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "expectedClockInTime", Yup.string().when("alertType", {
  is: "clock-in-reminder",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "expectedClockOutTime", Yup.string().when("alertType", {
  is: "early-clock-out-email-alert",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "alertSendTo", Yup.array().when("sendReminderTo", {
  is: function is(val) {
    return val === "selectivePersons";
  },
  then: function then(schema) {
    return schema.min(1, "Please select at least one user.");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "userPreferenceList", Yup.array().when("userPreferenceType", {
  is: function is(val) {
    return val === "selectedEmployees";
  },
  then: function then(schema) {
    return schema.min(1, "Please select at least one user.");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "idleNotificationInterval", Yup.string().when("alertType", {
  is: "high-idle-time",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "expectedIdleTime", Yup.string().when("alertType", {
  is: "high-idle-time",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "startTime", Yup.string().when("alertType", {
  is: "high-idle-time",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})), "endTime", Yup.string().when("alertType", {
  is: "high-idle-time",
  then: function then(schema) {
    return schema.required("Required");
  },
  otherwise: function otherwise(schema) {
    return schema.notRequired();
  }
})));
var RealTimeNotification = function RealTimeNotification(props) {
  var history = props.history;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    organisationBilling = _React$useContext.organisationBilling,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus,
    organisationTeamAndRole = _React$useContext.organisationTeamAndRole;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  React.useEffect(function () {
    if (organisationBilling.planId != "83844da8-71e8-4e94-b6ac-aaff5d8a858c" || (organisationSettings.enableRealTimeAlert == false || !organisationSettings.enableRealTimeAlert) && organisationBilling.planId == "83844da8-71e8-4e94-b6ac-aaff5d8a858c" && organisationId != "5da90b00-1205-11ee-99eb-6f59a4034ddc" && organisationId != "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" && organisationId != "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888") {
      props === null || props === void 0 ? void 0 : props.history.push("/overview");
    }
  }, [organisationSettings]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  console.log({
    enableRealTimeAlert: organisationSettings.enableRealTimeAlert
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "real-time-notification-root"
  }, organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationId == "5da90b00-1205-11ee-99eb-6f59a4034ddc" || organisationId == "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" || organisationId == "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || organisationSettings.enableRealTimeAlert ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(HeaderCard, {
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    userId: user.userId
  }), /*#__PURE__*/React.createElement(AlertTabDetails, {
    organisationSettings: organisationSettings,
    organisationBilling: organisationBilling,
    organisationId: organisationId,
    userId: user.userId,
    role: role,
    organisationTeamAndRole: organisationTeamAndRole
  })) : /*#__PURE__*/React.createElement(EnableRealTimeAlertMsg, null));
};
var EnableRealTimeAlertMsg = function EnableRealTimeAlertMsg(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "enable-real-time-alert-enable-help"
  }, /*#__PURE__*/React.createElement(IoMdAlert, {
    className: "enable-real-time-alert-enable-help-icon"
  }), "This is a Premium Plan feature. Reach us via chat support or email team@getworkfolio.com to request a 14-day trial and experience real-time alerts."), /*#__PURE__*/React.createElement("div", {
    className: "enable-real-time-alert-log-help-wrapper"
  }, /*#__PURE__*/React.createElement(AlertQuickGuide, null)));
};
var HeaderCard = function HeaderCard(props) {
  var _alertHeaderData$aler, _alertHeaderData$aler2, _alertHeaderData$aler3;
  var organisationId = props.organisationId,
    organisationSettings = props.organisationSettings,
    userId = props.userId;
  var _useQuery = useQuery(ALERT_RULE_HEADER_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        timezone: organisationSettings.organisationTimezone,
        userId: userId
      }
    }),
    alertHeaderData = _useQuery.data,
    alertHeaderError = _useQuery.error,
    alertHeaderLoading = _useQuery.loading;
  return /*#__PURE__*/React.createElement(Row, {
    className: "g-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    className: "shadow-sm border-0 rounded p-3 h-100 real-time-notification-header-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-muted real-time-notification-header-card-title"
  }, "Total Alerts"), /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold"
  }, " ", alertHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : alertHeaderError ? "Error" : alertHeaderData === null || alertHeaderData === void 0 ? void 0 : (_alertHeaderData$aler = alertHeaderData.alertRuleHeaderDetails) === null || _alertHeaderData$aler === void 0 ? void 0 : _alertHeaderData$aler.totalRuleCount)), /*#__PURE__*/React.createElement("div", {
    className: "real-time-notification-header-card-total-alerts-icon-wrapper"
  }, /*#__PURE__*/React.createElement(BsBell, {
    size: 24
  }))))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    className: "shadow-sm border-0 rounded p-3 h-100 real-time-notification-header-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-muted real-time-notification-header-card-title"
  }, "Active Rules"), /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold"
  }, " ", alertHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : alertHeaderError ? "Error" : alertHeaderData === null || alertHeaderData === void 0 ? void 0 : (_alertHeaderData$aler2 = alertHeaderData.alertRuleHeaderDetails) === null || _alertHeaderData$aler2 === void 0 ? void 0 : _alertHeaderData$aler2.activeRuleCount)), /*#__PURE__*/React.createElement("div", {
    className: "real-time-notification-header-card-active-rules-icon-wrapper"
  }, /*#__PURE__*/React.createElement(BsExclamationTriangle, {
    size: 24
  }))))), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    className: "shadow-sm border-0 rounded p-3 h-100 real-time-notification-header-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-muted real-time-notification-header-card-title"
  }, "Today Delivered Emails"), /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold"
  }, alertHeaderLoading ? /*#__PURE__*/React.createElement(Loader, null) : alertHeaderError ? "Error" : alertHeaderData === null || alertHeaderData === void 0 ? void 0 : (_alertHeaderData$aler3 = alertHeaderData.alertRuleHeaderDetails) === null || _alertHeaderData$aler3 === void 0 ? void 0 : _alertHeaderData$aler3.todayDeliveredAlerts)), /*#__PURE__*/React.createElement("div", {
    className: "real-time-notification-header-card-today-alerts-icon-wrapper"
  }, /*#__PURE__*/React.createElement(BsClock, {
    size: 24
  }))))));
};
var AlertTabDetails = function AlertTabDetails(props) {
  var organisationSettings = props.organisationSettings,
    organisationBilling = props.organisationBilling,
    organisationId = props.organisationId,
    userId = props.userId,
    role = props.role,
    organisationTeamAndRole = props.organisationTeamAndRole;
  var _useState = useState("config"),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalVisible = _useState4[0],
    setModalVisible = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    realTimeCount = _useState6[0],
    setRealTimeCount = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    helpModalVisible = _useState8[0],
    setHelpModalVisible = _useState8[1];
  var _React$useState = React.useState("all"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    alertTypeFilter = _React$useState2[0],
    setAlertTypeFilter = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    timeFilter = _React$useState4[0],
    setTimeFilter = _React$useState4[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-container"
  }, /*#__PURE__*/React.createElement("button", {
    className: "alert-tab-button ".concat(activeTab === "config" ? "active" : ""),
    onClick: function onClick() {
      return setActiveTab("config");
    }
  }, /*#__PURE__*/React.createElement(BsBell, {
    size: 18
  }), "Alert Configuration"), /*#__PURE__*/React.createElement("button", {
    className: "alert-tab-button ".concat(activeTab === "logs" ? "active" : ""),
    onClick: function onClick() {
      return setActiveTab("logs");
    }
  }, /*#__PURE__*/React.createElement(BsPeople, {
    size: 18
  }), "Alert Logs")), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-start mb-3"
  }, activeTab == "config" ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold alert-tab-title"
  }, "Alert Configuration"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-0 alert-tab-sub-title"
  }, "Configure smart alerts to help your team stay productive and engaged")), /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-button-wrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "d-flex align-items-center alert-tab-help-alert-button",
    onClick: function onClick() {
      return setHelpModalVisible(true);
    }
  }, /*#__PURE__*/React.createElement(IoIosHelpCircleOutline, {
    className: "alert-tab-alert-button-help-icon"
  }), "Help"), realTimeCount < 50 ? /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "d-flex align-items-center alert-tab-create-new-alert-button",
    onClick: function onClick() {
      return setModalVisible(true);
    }
  }, "+ Create New Alert") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "If you want to create more alerts, kindly contact our support.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "Teams-root-header-left-side-button upgrade-real-time-button-color"
  }, "+ Create New Alert")))) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-bold alert-tab-title"
  }, "Alert Logs"), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-0 alert-tab-sub-title"
  }, "Monitor alert delivery and employee engagement")))
  // null
  ), activeTab == "config" ? /*#__PURE__*/React.createElement(AlertConfig, {
    activeTab: activeTab,
    organisationId: organisationId,
    userId: userId,
    organisationSettings: organisationSettings,
    setRealTimeCount: setRealTimeCount,
    role: role,
    alertTypeFilter: alertTypeFilter,
    setAlertTypeFilter: setAlertTypeFilter,
    timeFilter: timeFilter,
    setTimeFilter: setTimeFilter
  }) : /*#__PURE__*/React.createElement(AlertLog, {
    organisationSettings: organisationSettings,
    organisationBilling: organisationBilling,
    activeTab: activeTab,
    organisationId: organisationId,
    userId: userId,
    role: role
  })), /*#__PURE__*/React.createElement(CreateAlertModal, {
    show: modalVisible,
    handleClose: function handleClose() {
      return setModalVisible(false);
    },
    organisationSettings: organisationSettings,
    organisationId: organisationId,
    userId: userId,
    role: role,
    organisationTeamAndRole: organisationTeamAndRole,
    alertTypeFilter: alertTypeFilter,
    timeFilter: timeFilter
  }), /*#__PURE__*/React.createElement(HelpAlertModal, {
    show: helpModalVisible,
    handleClose: function handleClose() {
      return setHelpModalVisible(false);
    }
  }));
};
var HelpAlertModal = function HelpAlertModal(props) {
  var show = props.show,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    role = props.role;
  if (!show) {
    return false;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "xl",
    className: "view-new-alert-modal",
    backdrop: "static" // disables outside click close
    ,
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "view-new-alert-modal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center view-new-alert-modal-header-name-div"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0 font-weight-bold view-new-alert-modal-header-text view-new-alert-modal-col-type-value-header"
  }, "Alert Configuration Help"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-new-alert-modal-body"
  }, /*#__PURE__*/React.createElement(AlertQuickGuide, null)));
};
var alertsDetails = [{
  iconColor: "#dbeafe",
  // light blue
  icon: /*#__PURE__*/React.createElement(GoClock, {
    className: "alert-tab-alert-rule-table-icon alert-tab-alert-rule-table-icon-go-clock"
  }),
  name: "Morning Clock-in Reminder",
  type: "clock-in-reminder",
  alertTypeIcon: /*#__PURE__*/React.createElement(BsClock, null)
}, {
  iconColor: "#ff000033",
  // light yellow
  icon: /*#__PURE__*/React.createElement(HiOutlineExclamationCircle, {
    className: "alert-tab-alert-rule-table-icon alert-tab-alert-rule-table-icon-exclamation-circle"
  }),
  name: "Late Clock-in Alert",
  type: "late-clock-in-email-alert",
  alertTypeIcon: /*#__PURE__*/React.createElement(HiOutlineExclamationCircle, null)
}, {
  iconColor: "rgb(237 197 26 / 19%)",
  // light green
  icon: /*#__PURE__*/React.createElement(HiLogout, {
    className: "alert-tab-alert-rule-table-icon alert-tab-alert-rule-table-icon-logout"
  }),
  name: "Early Clock-out Alert",
  type: "early-clock-out-email-alert",
  alertTypeIcon: /*#__PURE__*/React.createElement(HiLogout, null)
}, {
  iconColor: "rgb(147 51 234 / 17%)",
  // light red
  icon: /*#__PURE__*/React.createElement(FaUserTimes, {
    className: "alert-tab-alert-rule-table-icon alert-tab-alert-rule-table-icon-user-times"
  }),
  name: "Employee Absence Alert",
  type: "absence-email-alert",
  alertTypeIcon: /*#__PURE__*/React.createElement(FaUserTimes, null)
}, {
  iconColor: "#ffa5003d",
  // light red
  icon: /*#__PURE__*/React.createElement(FaDesktop, {
    className: "alert-tab-alert-rule-table-icon alert-tab-alert-rule-table-icon-desktop"
  }),
  name: "Exccess of Idle Time",
  type: "high-idle-time",
  alertTypeIcon: /*#__PURE__*/React.createElement(BsDisplay, null)
}];
function CustomToggle(_ref) {
  var initialStatus = _ref.initialStatus,
    alertId = _ref.alertId,
    onStatusChange = _ref.onStatusChange,
    updateAlertNotificationStatusLoading = _ref.updateAlertNotificationStatusLoading,
    alertStatusList = _ref.alertStatusList,
    setAlertStatusList = _ref.setAlertStatusList;
  var handleToggle = function handleToggle() {
    var newStatus = !initialStatus;
    // setStatus(newStatus);
    setAlertStatusList(function (prev) {
      return prev.includes(alertId) ? prev.filter(function (id) {
        return id !== alertId;
      }) // remove
      : [].concat(_toConsumableArray(prev), [alertId]);
    } // add
    );
    onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange({
      status: newStatus,
      alertId: alertId
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center alert-tab-alert-rule-table-status-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-control custom-switch"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "custom-control-input",
    id: "customSwitch-".concat(alertId),
    checked: initialStatus,
    onChange: handleToggle,
    disabled: alertStatusList.includes(alertId) && updateAlertNotificationStatusLoading
  }), /*#__PURE__*/React.createElement("label", {
    className: "custom-control-label",
    htmlFor: "customSwitch-".concat(alertId)
  })), /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    variant: initialStatus ? "success" : "secondary"
  }, updateAlertNotificationStatusLoading && alertStatusList.includes(alertId) ? "Updating" : initialStatus ? "Active" : "Inactive"));
}
function formatIdleInterval(idleNotificationInterval, startTime, endTime) {
  var intervalMap = {
    1: "One hour once",
    2: "Two hours once",
    3: "Three hours once",
    4: "Four hours once",
    5: "Five hours once",
    6: "Six hours once",
    10: "Ten mins once"
    // add more if needed
  };
  var label = intervalMap[idleNotificationInterval] || "".concat(idleNotificationInterval, " hours once");
  return "".concat(label, " (").concat(startTime, " to ").concat(endTime, ")");
}
var AlertConfig = function AlertConfig(props) {
  var _listRealTimeAlertDat6, _listRealTimeAlertDat7;
  var activeTab = props.activeTab,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    setRealTimeCount = props.setRealTimeCount,
    role = props.role,
    alertTypeFilter = props.alertTypeFilter,
    setAlertTypeFilter = props.setAlertTypeFilter,
    timeFilter = props.timeFilter,
    setTimeFilter = props.setTimeFilter;
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAllLoaded = _React$useState6[0],
    setIsAllLoaded = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadingMore = _React$useState8[0],
    setIsLoadingMore = _React$useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    editAlertModalVisible = _useState10[0],
    setEditAlertModalVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    viewAlertModalVisible = _useState12[0],
    setViewAlertModalVisible = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    alertStatusList = _useState14[0],
    setAlertStatusList = _useState14[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    showDeleteModal = _React$useState10[0],
    setShowDeleteModal = _React$useState10[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    localStatus = _useState16[0],
    setLocalStatus = _useState16[1];
  var currentTimezone = organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone;
  var alertTypes = [{
    label: "All Alert Types",
    value: "all"
  }].concat(alertTypeForAdd);
  var getDateRangeFromFilter = function getDateRangeFromFilter(filter) {
    var tz = currentTimezone;
    switch (filter) {
      case "today":
        return {
          startDate: moment().tz(tz).startOf("day").toISOString(),
          endDate: moment().tz(tz).endOf("day").toISOString()
        };
      case "this_week":
        return {
          startDate: moment().tz(tz).startOf("week").toISOString(),
          endDate: moment().tz(tz).endOf("week").toISOString()
        };
      case "this_month":
        return {
          startDate: moment().tz(tz).startOf("month").toISOString(),
          endDate: moment().tz(tz).endOf("month").toISOString()
        };
      case "last_7_days":
        return {
          startDate: moment().tz(tz).subtract(7, "days").startOf("day").toISOString(),
          endDate: moment().tz(tz).endOf("day").toISOString()
        };
      case "last_30_days":
        return {
          startDate: moment().tz(tz).subtract(30, "days").startOf("day").toISOString(),
          endDate: moment().tz(tz).endOf("day").toISOString()
        };
      default:
        return {
          startDate: undefined,
          endDate: undefined
        };
    }
  };
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
  };
  var handleDeleteShow = function handleDeleteShow(_ref2) {
    var alertId = _ref2.alertId;
    setShowDeleteModal({
      alertId: alertId
    });
  };
  var _useLazyQuery = useLazyQuery(LIST_REAL_TIME_ALERT_NOTIFICATION_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getListRealTimeAlert = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    listRealTimeAlertData = _useLazyQuery2$.data,
    listRealTimeAlertError = _useLazyQuery2$.error,
    listRealTimeAlertLoading = _useLazyQuery2$.loading,
    listRealTimeAlertFetchMore = _useLazyQuery2$.fetchMore;
  React.useEffect(function () {
    if (activeTab == "config") {
      var _getDateRangeFromFilt = getDateRangeFromFilter(timeFilter),
        startDate = _getDateRangeFromFilt.startDate,
        endDate = _getDateRangeFromFilt.endDate;
      getListRealTimeAlert({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          userId: userId,
          alertType: alertTypeFilter || undefined,
          alertTime: timeFilter
        },
        skip: !organisationId
      });
      setIsAllLoaded(false);
    }
  }, [activeTab, alertTypeFilter, timeFilter]);
  React.useEffect(function () {
    var _listRealTimeAlertDat, _listRealTimeAlertDat2;
    if ((listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat === void 0 ? void 0 : _listRealTimeAlertDat.length) !== 0 && (listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat2 = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat2 === void 0 ? void 0 : _listRealTimeAlertDat2.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : listRealTimeAlertData.listRealTimeAlertNotification]);
  React.useEffect(function () {
    var _listRealTimeAlertDat3;
    if (listRealTimeAlertData !== null && listRealTimeAlertData !== void 0 && (_listRealTimeAlertDat3 = listRealTimeAlertData.listRealTimeAlertNotification) !== null && _listRealTimeAlertDat3 !== void 0 && _listRealTimeAlertDat3.length) {
      var _listRealTimeAlertDat4;
      setRealTimeCount(listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat4 = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat4 === void 0 ? void 0 : _listRealTimeAlertDat4.length);
    }
  }, [listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : listRealTimeAlertData.listRealTimeAlertNotification]);
  var handleLoadMore = function handleLoadMore() {
    var _listRealTimeAlertDat5;
    if (listRealTimeAlertLoading) return;
    setIsLoadingMore(true);
    listRealTimeAlertFetchMore({
      variables: {
        offset: listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat5 = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat5 === void 0 ? void 0 : _listRealTimeAlertDat5.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$list, _fetchMoreResult$list2;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$list = fetchMoreResult.listRealTimeAlertNotification) === null || _fetchMoreResult$list === void 0 ? void 0 : _fetchMoreResult$list.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$list2 = fetchMoreResult.listRealTimeAlertNotification) === null || _fetchMoreResult$list2 === void 0 ? void 0 : _fetchMoreResult$list2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          listRealTimeAlertNotification: [].concat(_toConsumableArray(prev.listRealTimeAlertNotification), _toConsumableArray(fetchMoreResult.listRealTimeAlertNotification))
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  var _useMutation = useMutation(UPDATE_ALERT_NOTIFICATION_STATUS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateAlertNotificationStatus = _useMutation2[0],
    updateAlertNotificationStatusLoading = _useMutation2[1].loading;
  var onAlertStatusChange = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref4) {
      var status, alertId, startTime, endTime, idleNotificationInterval, alertType, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            status = _ref4.status, alertId = _ref4.alertId, startTime = _ref4.startTime, endTime = _ref4.endTime, idleNotificationInterval = _ref4.idleNotificationInterval, alertType = _ref4.alertType;
            variables = {
              alertId: alertId,
              organisationId: organisationId,
              userId: userId,
              status: status,
              startTime: startTime,
              endTime: endTime,
              idleNotificationInterval: idleNotificationInterval,
              alertType: alertType,
              tz: organisationSettings.organisationTimezone
            };
            _context.prev = 2;
            _context.next = 5;
            return updateAlertNotificationStatus({
              variables: variables,
              update: function update(cache) {
                cache.modify({
                  fields: {
                    listRealTimeAlertNotification: function listRealTimeAlertNotification() {
                      var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                      return existing.map(function (item) {
                        return item.alertId === alertId ? _objectSpread(_objectSpread({}, item), {}, {
                          status: status
                        }) : item;
                      });
                    }
                  }
                });
                cache.modify({
                  fields: {
                    alertRuleHeaderDetails: function alertRuleHeaderDetails(existing) {
                      return _objectSpread(_objectSpread({}, existing), {}, {
                        activeRuleCount: status ? ((existing === null || existing === void 0 ? void 0 : existing.activeRuleCount) || 0) + 1 : Math.max(((existing === null || existing === void 0 ? void 0 : existing.activeRuleCount) || 0) - 1, 0)
                      });
                    }
                  }
                });
              }
            });
          case 5:
            response = _context.sent;
            if (!(!response || !response.data || response.data.updateAlertNotificationStatus == null)) {
              _context.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            // setTeamActive
            toast.success("Alert status updated successfully!");
            setAlertStatusList(function (prev) {
              return prev.filter(function (id) {
                return id !== alertId;
              });
            });
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            toast.error("Error Occured, Try again later!");
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 15]]);
    }));
    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [updateAlertNotificationStatus, updateAlertNotificationStatusLoading]);
  var _useQuery2 = useQuery(REAL_TIME_ALERT_TIME_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !organisationId
    }),
    realTimeListData = _useQuery2.data,
    realTimeListError = _useQuery2.error,
    realTimeListLoading = _useQuery2.loading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-log-filter-card-wrapper"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center alert-tab-alert-log-filter-card-wrapper-row"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Select, {
    value: alertTypes.filter(function (option) {
      return alertTypeFilter === option.value;
    }),
    onChange: function onChange(e) {
      return setAlertTypeFilter(e.value);
    },
    options: alertTypes,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown",
    styles: {
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      }
    }
  })), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Select, {
    value: realTimeListData === null || realTimeListData === void 0 ? void 0 : realTimeListData.realTimeAlertTimeList.filter(function (option) {
      return timeFilter === option.value;
    }),
    onChange: function onChange(e) {
      return setTimeFilter(e.value);
    },
    options: realTimeListData === null || realTimeListData === void 0 ? void 0 : realTimeListData.realTimeAlertTimeList,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown",
    styles: {
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      }
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-wrapper"
  }, listRealTimeAlertLoading ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-data"
  }, /*#__PURE__*/React.createElement(Loader, null)) : listRealTimeAlertError ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page."), " ") : (alertTypeFilter || timeFilter) && listRealTimeAlertData && (listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : listRealTimeAlertData.listRealTimeAlertNotification.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-alert-text"
  }, "No alert found !!!")) : listRealTimeAlertData && (listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : listRealTimeAlertData.listRealTimeAlertNotification.length) == 0 ? /*#__PURE__*/React.createElement(AlertQuickGuide, null) :
  // <div className="alert-tab-alert-rule-container-alert-table-no-data">
  //   <div className="real-time-alert-rule-no-data">Real-time alert rule not added yet</div>
  // </div>
  listRealTimeAlertData && (listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : listRealTimeAlertData.listRealTimeAlertNotification.length) != 0 ? /*#__PURE__*/React.createElement(Table, {
    hover: true,
    responsive: true,
    className: "alert-tab-alert-rule-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Rule Name"), /*#__PURE__*/React.createElement("th", null, "Type"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Recipients"), /*#__PURE__*/React.createElement("th", null, "Mail Trigger Time"), /*#__PURE__*/React.createElement("th", null, "Actions"))), /*#__PURE__*/React.createElement("tbody", null, listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat6 = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat6 === void 0 ? void 0 : _listRealTimeAlertDat6.map(function (alert, idx) {
    var _alertsDetails$find, _alertTypeForList$fin, _sendTo$length, _sendTo$length2, _sendTo$length3;
    var alertId = alert.alertId,
      ruleName = alert.ruleName,
      alertType = alert.alertType,
      expectedClockInTime = alert.expectedClockInTime,
      sendEmailAt = alert.sendEmailAt,
      sendReminderTo = alert.sendReminderTo,
      notificationMethod = alert.notificationMethod,
      expectedIdleTime = alert.expectedIdleTime,
      sendTo = alert.sendTo,
      status = alert.status,
      idleAlertNextAt = alert.idleAlertNextAt,
      startTime = alert.startTime,
      endTime = alert.endTime,
      idleNotificationInterval = alert.idleNotificationInterval;
    var alertIconData = (_alertsDetails$find = alertsDetails.find(function (details) {
      return details.type === alertType;
    })) !== null && _alertsDetails$find !== void 0 ? _alertsDetails$find : {};
    var alertValues = (_alertTypeForList$fin = alertTypeForList.find(function (details) {
      return details.value === alertType;
    })) !== null && _alertTypeForList$fin !== void 0 ? _alertTypeForList$fin : {};
    return /*#__PURE__*/React.createElement("tr", {
      key: idx
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center alert-tab-alert-rule-table-td-data",
      onClick: function onClick() {
        return setViewAlertModalVisible(_objectSpread(_objectSpread({}, alert), {}, {
          alertTypeLabel: alertValues.label,
          iconBackgroundColor: alertIconData.iconColor,
          icon: alertIconData.icon
        }));
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-tab-alert-rule-table-icon-wrapper",
      style: {
        backgroundColor: alertIconData.iconColor
      }
    }, alertIconData.icon), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, ruleName)
    }, /*#__PURE__*/React.createElement("span", {
      className: "alert-tab-alert-rule-table-rule-name"
    }, ruleName)))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Badge, {
      pill: true,
      variant: "light",
      className: "border text-dark alert-tab-alert-rule-table-alert-type alert-tab-alert-rule-table-td-data",
      onClick: function onClick() {
        return setViewAlertModalVisible(_objectSpread(_objectSpread({}, alert), {}, {
          alertTypeLabel: alertValues.label,
          iconBackgroundColor: alertIconData.iconColor,
          icon: alertIconData.icon
        }));
      }
    }, alertValues.label)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(CustomToggle, {
      initialStatus: status,
      alertId: alertId,
      onStatusChange: function onStatusChange(_ref6) {
        var status = _ref6.status,
          alertId = _ref6.alertId;
        onAlertStatusChange({
          status: status,
          alertId: alertId,
          startTime: startTime,
          endTime: endTime,
          idleNotificationInterval: idleNotificationInterval,
          alertType: alertType
        });
        // Call your mutation or API here
      },
      updateAlertNotificationStatusLoading: updateAlertNotificationStatusLoading,
      alertStatusList: alertStatusList,
      setAlertStatusList: setAlertStatusList
    })), /*#__PURE__*/React.createElement("td", {
      className: "alert-tab-alert-rule-table-team-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-tab-alert-rule-table-td-data",
      onClick: function onClick() {
        return setViewAlertModalVisible(_objectSpread(_objectSpread({}, alert), {}, {
          alertTypeLabel: alertValues.label,
          iconBackgroundColor: alertIconData.iconColor,
          icon: alertIconData.icon
        }));
      }
    }, /*#__PURE__*/React.createElement(HiOutlineUser, {
      className: "mr-1 alert-tab-alert-rule-table-team-wrapper-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "alert-tab-alert-rule-table-team-reminder-name"
    }, sendReminderTo == "everyone" ? "Everyone" : sendReminderTo == "teamMembers" ? "Members" : sendReminderTo == "teamMembers&teamHead" ? "Members & Head" : sendReminderTo == "admin" ? "Admin" : sendReminderTo == "respectiveTeamMembers" ? "Respective Members" : ((_sendTo$length = sendTo === null || sendTo === void 0 ? void 0 : sendTo.length) !== null && _sendTo$length !== void 0 ? _sendTo$length : 0) > 1 ? "".concat((_sendTo$length2 = sendTo === null || sendTo === void 0 ? void 0 : sendTo.length) !== null && _sendTo$length2 !== void 0 ? _sendTo$length2 : 0, " Members") : "".concat((_sendTo$length3 = sendTo === null || sendTo === void 0 ? void 0 : sendTo.length) !== null && _sendTo$length3 !== void 0 ? _sendTo$length3 : 0, " Member")))), /*#__PURE__*/React.createElement("td", {
      className: "alert-tab-alert-rule-table-threshold alert-tab-alert-rule-table-td-data",
      onClick: function onClick() {
        return setViewAlertModalVisible(_objectSpread(_objectSpread({}, alert), {}, {
          alertTypeLabel: alertValues.label,
          iconBackgroundColor: alertIconData.iconColor,
          icon: alertIconData.icon
        }));
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-tab-alert-rule-table-td-notification-interval"
    }, alertType == "high-idle-time" ? formatIdleInterval(idleNotificationInterval, startTime, endTime) : sendEmailAt)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      size: "sm",
      className: "mr-2 alert-tab-alert-rule-table-action-button",
      onClick: function onClick() {
        return setViewAlertModalVisible(_objectSpread(_objectSpread({}, alert), {}, {
          alertTypeLabel: alertValues.label,
          iconBackgroundColor: alertIconData.iconColor,
          icon: alertIconData.icon
        }));
      }
    }, /*#__PURE__*/React.createElement(HiOutlineEye, {
      className: "alert-tab-alert-rule-table-action-icon"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      size: "sm",
      className: "mr-2 alert-tab-alert-rule-table-action-button",
      onClick: function onClick() {
        return setEditAlertModalVisible(alert);
      }
    }, /*#__PURE__*/React.createElement(BsPencil, {
      className: "alert-tab-alert-rule-table-action-icon"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      size: "sm",
      className: "alert-tab-alert-rule-table-action-button",
      onClick: function onClick() {
        return handleDeleteShow({
          alertId: alertId
        });
      }
    }, /*#__PURE__*/React.createElement(BsTrash, {
      className: "alert-tab-alert-rule-table-action-icon"
    }))));
  }))) : null, !listRealTimeAlertLoading && listRealTimeAlertData && (listRealTimeAlertData === null || listRealTimeAlertData === void 0 ? void 0 : (_listRealTimeAlertDat7 = listRealTimeAlertData.listRealTimeAlertNotification) === null || _listRealTimeAlertDat7 === void 0 ? void 0 : _listRealTimeAlertDat7.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the rules")) : null)), /*#__PURE__*/React.createElement(EditAlertModal, {
    show: editAlertModalVisible,
    handleClose: function handleClose() {
      return setEditAlertModalVisible(false);
    },
    organisationId: organisationId,
    userId: userId,
    organisationSettings: organisationSettings,
    role: role
  }), /*#__PURE__*/React.createElement(ViewAlertModal, {
    show: viewAlertModalVisible,
    handleClose: function handleClose() {
      return setViewAlertModalVisible(false);
    },
    organisationId: organisationId,
    userId: userId,
    organisationSettings: organisationSettings,
    role: role
  }), /*#__PURE__*/React.createElement(DeleteAlertRuleModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    organisationId: organisationId,
    userId: userId,
    organisationSettings: organisationSettings
  }));
};
var AlertQuickGuide = function AlertQuickGuide(props) {
  var alerts = [{
    icon: "⏰",
    label: "Clock-in Reminder",
    title: "Gentle nudge before the day begins",
    description: "Emails go out just before the official clock-in time.",
    steps: ["Choose Clock-in Reminder.", "Set Expected Clock-in Time (e.g., 09:00 AM).", "Set Send Reminder At (e.g., 08:45 AM).", "Choose days and recipients.", "Save."]
  }, {
    icon: "⏱",
    label: "Late Clock-in Alert",
    title: "Highlights late arrivals",
    description: "Sends a summary of late clock-ins to your chosen recipients.",
    steps: ["Choose Late Clock-in Email Alert.", "Set Expected Clock-in Time (e.g., 09:00 AM).", "Set Email Notification Time (e.g., 09:30 AM).", "Choose days and which employees to include.", "Save."]
  }, {
    icon: "🧑‍💼",
    label: "Absence Alert",
    title: "Catch missed clock-ins",
    description: "Flags employees who haven’t clocked in by your set time.",
    steps: ["Choose Absence Email Alert.", "Set Expected Clock-in Time.", "Set Email Notification Time.", "Choose days and which employees to include.", "Save."]
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "alert-quick-guide-banner"
  }, /*#__PURE__*/React.createElement(Row, {
    noGutters: true,
    className: "align-items-center"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-quick-guide-icon-wrapper"
  }, /*#__PURE__*/React.createElement(AiOutlineBell, {
    className: "alert-quick-guide-bell-icon"
  }))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    className: "alert-quick-guide-title alert-header-quick-guide-title"
  }, "Real Time Alert \u2013 Quick Guide"), /*#__PURE__*/React.createElement("p", {
    className: "alert-quick-guide-subtitle alert-header-quick-guide-subtitle"
  }, "Set up powerful, automated notifications in minutes.")))), /*#__PURE__*/React.createElement(Container, {
    className: "alert-quick-guide-container"
  }, /*#__PURE__*/React.createElement(Row, null, alerts.map(function (alert, idx) {
    return /*#__PURE__*/React.createElement(Col, {
      md: 4,
      key: idx,
      className: "mb-4"
    }, /*#__PURE__*/React.createElement(Card, {
      className: "alert-quick-guide-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-quick-guide-badge"
    }, /*#__PURE__*/React.createElement("span", {
      className: "alert-quick-guide-icon"
    }, alert.icon), alert.label), /*#__PURE__*/React.createElement("h5", {
      className: "alert-quick-guide-title"
    }, alert.title), /*#__PURE__*/React.createElement("p", {
      className: "alert-quick-guide-description"
    }, alert.description), /*#__PURE__*/React.createElement("div", {
      className: "alert-quick-guide-steps"
    }, alert.steps.map(function (step, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "alert-quick-guide-step-item"
      }, " ", /*#__PURE__*/React.createElement(AiOutlineCheckCircle, {
        className: "alert-quick-guide-steps-circle-icon"
      }), step);
    }))));
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "alert-quick-guide-tip"
  }, /*#__PURE__*/React.createElement("strong", null, "Tip"), " ", /*#__PURE__*/React.createElement("br", null), "Use reminders for everyone, and late/absence alerts for managers or HR. You can edit, pause, or delete alerts anytime from the Alert Configuration tab.")))));
};
var AlertLog = function AlertLog(props) {
  var organisationSettings = props.organisationSettings,
    organisationBilling = props.organisationBilling,
    activeTab = props.activeTab,
    organisationId = props.organisationId,
    userId = props.userId,
    role = props.role;
  var currentTimezone = organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone;
  // const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone ;

  var _React$useState11 = React.useState({
      startDate: startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("month").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("month").toDate() : moment().tz(currentTimezone).clone().startOf("month").toDate(),
      endDate: startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("month").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("month").toDate() : moment().tz(currentTimezone).clone().endOf("month").toDate()
    }),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    dates = _React$useState12[0],
    setDate = _React$useState12[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState13 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    filterData = _React$useState14[0],
    setFilterData = _React$useState14[1];
  var _React$useState15 = React.useState([{
      label: "All Employees",
      value: ""
    }]),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    userList = _React$useState16[0],
    setUserList = _React$useState16[1];
  var _React$useState17 = React.useState(""),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    userFilter = _React$useState18[0],
    setUserFilter = _React$useState18[1];
  var _React$useState19 = React.useState(""),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    alertTypeFilter = _React$useState20[0],
    setAlertTypeFilter = _React$useState20[1];
  var _React$useState21 = React.useState(""),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    alertStatusFilter = _React$useState22[0],
    setAlertStatusFilter = _React$useState22[1];
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
    setFilterData(arrayToStringOutput([dates.startDate, dates.endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  var _useLazyQuery3 = useLazyQuery(MEMBER_LIST_FOR_ALERT_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getMemberListData = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    memberListData = _useLazyQuery4$.data,
    memberListError = _useLazyQuery4$.error,
    memberListLoading = _useLazyQuery4$.loading;
  React.useEffect(function () {
    if (activeTab == "logs") {
      getMemberListData({
        variables: {
          organisationId: organisationId,
          userId: userId,
          role: role
        },
        skip: !organisationId
      });
    }
  }, [activeTab]);
  React.useEffect(function () {
    if (memberListData !== null && memberListData !== void 0 && memberListData.memberListForAlert) {
      var _memberListData$membe;
      var memberData = memberListData === null || memberListData === void 0 ? void 0 : (_memberListData$membe = memberListData.memberListForAlert) === null || _memberListData$membe === void 0 ? void 0 : _memberListData$membe.map(function (item) {
        var userId = item.userId,
          displayName = item.displayName;
        return {
          label: displayName,
          value: userId
        };
      });
      setUserList([{
        label: "All Employees",
        value: ""
      }].concat(_toConsumableArray(memberData)));
    }
  }, [memberListData]);
  var alertTypes = [{
    label: "All Alert Types",
    value: ""
  }].concat(alertTypeForAdd);
  var alertStatus = [{
    label: "All Statuses",
    value: ""
  }, {
    label: "Sent",
    value: "success"
  },
  // { label: "Delivered", value: "delivered" },
  // { label: "Read", value: "read" },
  {
    label: "Error",
    value: "error"
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-log-filter-card-wrapper"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center alert-tab-alert-log-filter-card-wrapper-row"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "real-time-alert-header-filter-wrapper"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onFilterChange: onFilterChange,
      startDate: startDate,
      endDate: endDate,
      filterData: filterData,
      onClose: hideOverlay,
      organisationBilling: organisationBilling,
      organisationSettings: organisationSettings
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "real-time-alert-header-filter-date"
  }, /*#__PURE__*/React.createElement(FaRegCalendarAlt, {
    className: "page-content-wrapper-menu-filter-date-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "payroll-summary-header-filter-date-text"
  }, arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)))))), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Select, {
    value: userList.filter(function (option) {
      return userFilter == option.value;
    }),
    onChange: function onChange(e) {
      return setUserFilter(e.value);
    },
    options: userList
    //defaultMenuIsOpen={true}
    ,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown",
    styles: {
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      }
    }
  })), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Select, {
    value: alertTypes.filter(function (option) {
      return alertTypeFilter == option.value;
    }),
    onChange: function onChange(e) {
      return setAlertTypeFilter(e.value);
    },
    options: alertTypes
    //defaultMenuIsOpen={true}
    ,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown",
    styles: {
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      }
    }
  })), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(Select, {
    value: alertStatus.filter(function (option) {
      return alertStatusFilter == option.value;
    }),
    onChange: function onChange(e) {
      return setAlertStatusFilter(e.value);
    },
    options: alertStatus
    //defaultMenuIsOpen={true}
    ,
    menuPosition: "fixed",
    className: "payroll-setup-modal-dropdown",
    styles: {
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      },
      control: function control(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: "100%"
        });
      }
    }
  })))), /*#__PURE__*/React.createElement(AlertTable, {
    organisationId: organisationId,
    startDate: startDate,
    endDate: endDate,
    userFilter: userFilter,
    alertTypeFilter: alertTypeFilter,
    alertStatusFilter: alertStatusFilter,
    organisationSettings: organisationSettings,
    activeTab: activeTab,
    userId: userId,
    role: role
  }));
};
var AlertSummary = function AlertSummary() {
  var stats = [{
    label: "Total Alerts",
    value: 6,
    color: "#0f172a"
  },
  // slate-900
  {
    label: "Read",
    value: 3,
    color: "#16a34a"
  },
  // green-600
  {
    label: "Delivered",
    value: 1,
    color: "#b45309"
  },
  // amber-700
  {
    label: "Failed",
    value: 1,
    color: "#dc2626"
  } // red-600
  ];
  return /*#__PURE__*/React.createElement(Row, {
    className: "mb-4 alert-log-alert-summary-card-wrapper"
  }, stats.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Col, {
      key: idx,
      md: 3
    }, /*#__PURE__*/React.createElement(Card, {
      className: "alert-log-alert-summary-card"
    }, /*#__PURE__*/React.createElement(Card.Body, {
      className: "p-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-log-alert-summary-card-number-text",
      style: {
        color: item.color
      }
    }, item.value), /*#__PURE__*/React.createElement("div", {
      className: "alert-log-alert-summary-card-label-text"
    }, item.label))));
  }));
};
var AlertTable = function AlertTable(props) {
  var _alerRuletLogsData$al4, _alerRuletLogsData$al5, _alerRuletLogsData$al6, _alerRuletLogsData$al7;
  var organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    userFilter = props.userFilter,
    alertTypeFilter = props.alertTypeFilter,
    alertStatusFilter = props.alertStatusFilter,
    organisationSettings = props.organisationSettings,
    activeTab = props.activeTab,
    userId = props.userId,
    role = props.role;
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isAllLoaded = _React$useState24[0],
    setIsAllLoaded = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isLoadingMore = _React$useState26[0],
    setIsLoadingMore = _React$useState26[1];
  var _useLazyQuery5 = useLazyQuery(ALERT_RULE_LOGS_QUERY),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getAlertRuleLogs = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    alerRuletLogsData = _useLazyQuery6$.data,
    alertRuleLogsError = _useLazyQuery6$.error,
    alertRuleLogsLoading = _useLazyQuery6$.loading,
    alertRuleLogsFetchMore = _useLazyQuery6$.fetchMore;
  React.useEffect(function () {
    if (activeTab == "logs") {
      getAlertRuleLogs({
        variables: {
          organisationId: organisationId,
          limit: LIMIT,
          offset: 0,
          startDate: startDate,
          endDate: endDate ? endDate : startDate,
          userFilter: userFilter,
          alertType: alertTypeFilter,
          status: alertStatusFilter,
          timezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          userId: userId
        },
        skip: !organisationId
      });
    }
  }, [activeTab, startDate, endDate, userFilter, alertTypeFilter, alertStatusFilter]);
  React.useEffect(function () {
    if (activeTab == "logs") {
      setIsAllLoaded(false);
      setIsLoadingMore(false);
    }
  }, [activeTab, startDate, endDate, userFilter, alertTypeFilter, alertStatusFilter]);
  React.useEffect(function () {
    var _alerRuletLogsData$al, _alerRuletLogsData$al2;
    if ((alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al === void 0 ? void 0 : _alerRuletLogsData$al.length) !== 0 && (alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al2 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al2 === void 0 ? void 0 : _alerRuletLogsData$al2.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : alerRuletLogsData.alertRuleLogs]);
  var handleLoadMore = function handleLoadMore() {
    var _alerRuletLogsData$al3;
    if (alertRuleLogsLoading) return;
    setIsLoadingMore(true);
    alertRuleLogsFetchMore({
      variables: {
        offset: alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al3 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al3 === void 0 ? void 0 : _alerRuletLogsData$al3.length
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var _fetchMoreResult$aler, _fetchMoreResult$aler2;
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$aler = fetchMoreResult.alertRuleLogs) === null || _fetchMoreResult$aler === void 0 ? void 0 : _fetchMoreResult$aler.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$aler2 = fetchMoreResult.alertRuleLogs) === null || _fetchMoreResult$aler2 === void 0 ? void 0 : _fetchMoreResult$aler2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          alertRuleLogs: [].concat(_toConsumableArray(prev.alertRuleLogs), _toConsumableArray(fetchMoreResult.alertRuleLogs))
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "alert-log-alert-table-wrapper"
  }, alertRuleLogsLoading ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-data"
  }, " ", /*#__PURE__*/React.createElement(Loader, null)) : alertRuleLogsError ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-data"
  }, " ", /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.")) : alerRuletLogsData && (alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al4 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al4 === void 0 ? void 0 : _alerRuletLogsData$al4.length) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-container-alert-table-no-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "real-time-alert-rule-no-data"
  }, "Real-time alert log not found !!!")) : alerRuletLogsData && (alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al5 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al5 === void 0 ? void 0 : _alerRuletLogsData$al5.length) != 0 ? /*#__PURE__*/React.createElement(Table, {
    responsive: true,
    hover: true,
    className: "mb-0 alert-log-alert-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Employee"), /*#__PURE__*/React.createElement("th", null, "Alert Type"), /*#__PURE__*/React.createElement("th", null, "Method"), /*#__PURE__*/React.createElement("th", null, "Alert Name"), /*#__PURE__*/React.createElement("th", null, "Time"), /*#__PURE__*/React.createElement("th", null, "Status"))), /*#__PURE__*/React.createElement("tbody", null, alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al6 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al6 === void 0 ? void 0 : _alerRuletLogsData$al6.map(function (alert, idx) {
    var status = alert.status,
      addedAt = alert.addedAt,
      userId = alert.userId,
      alertType = alert.alertType,
      alertSendMethod = alert.alertSendMethod,
      alertId = alert.alertId,
      ruleName = alert.ruleName,
      displayName = alert.displayName,
      profileUrl = alert.profileUrl;
    var alertIconValues = alertsDetails.find(function (details) {
      return details.type === alertType;
    });
    var alertValues = alertTypeForList.find(function (details) {
      return details.value === alertType;
    });
    return /*#__PURE__*/React.createElement("tr", {
      key: idx
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "alert-log-alert-table-avatar-profile-wrapper"
    }, profileUrl ? /*#__PURE__*/React.createElement("div", {
      className: "alert-log-alert-table-profile-card-payroll-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: profileUrl,
      className: "alert-log-alert-table-profile-card-payroll-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "bg-light rounded-circle d-inline-flex align-items-center justify-content-center alert-log-alert-table-profile-card-avator"
    }, /*#__PURE__*/React.createElement(MdPerson, {
      className: "alert-log-alert-table-profile-card-avator-icon"
    }))), /*#__PURE__*/React.createElement("span", null, displayName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, alertIconValues.alertTypeIcon, /*#__PURE__*/React.createElement("span", {
      className: "ml-2"
    }, alertValues.label))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, alertSendMethod == "email" ? /*#__PURE__*/React.createElement(BsEnvelope, null) : alertSendMethod == "slack" ? /*#__PURE__*/React.createElement(BsExclamationCircle, null) : /*#__PURE__*/React.createElement(BsBell, null), /*#__PURE__*/React.createElement("span", {
      className: "ml-2 alert-log-alert-table-alert-send-method"
    }, alertSendMethod))), /*#__PURE__*/React.createElement("td", {
      style: {
        maxWidth: "250px"
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, ruleName)
    }, /*#__PURE__*/React.createElement("span", {
      className: "alert-tab-alert-rule-table-rule-name"
    }, ruleName))), /*#__PURE__*/React.createElement("td", null, moment(addedAt).format("MMM DD, hh:mm A")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Badge, {
      variant: status == "success" ? "success" : "danger",
      className: "alert-log-alert-table-alert-status"
    }, status == "success" ? "Sent" : "Failed")));
  }))) : null, !alertRuleLogsLoading && alerRuletLogsData && (alerRuletLogsData === null || alerRuletLogsData === void 0 ? void 0 : (_alerRuletLogsData$al7 = alerRuletLogsData.alertRuleLogs) === null || _alerRuletLogsData$al7 === void 0 ? void 0 : _alerRuletLogsData$al7.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the logs")) : null);
};
var alertTypeForList = [{
  label: "Clock-in Reminder",
  value: "clock-in-reminder"
}, {
  label: "Late Clock-in Email Alert",
  value: "late-clock-in-email-alert"
}, {
  label: "Early Clock-out Email Alert",
  value: "early-clock-out-email-alert"
}, {
  label: "Absence Email Alert",
  value: "absence-email-alert"
}, {
  label: "Excess of Idle Time",
  value: "high-idle-time"
}];
var alertTypeForAdd = [{
  label: "Clock-in Reminder",
  value: "clock-in-reminder"
}, {
  label: "Late Clock-in Email Alert",
  value: "late-clock-in-email-alert"
}, {
  label: "Early Clock-out Email Alert",
  value: "early-clock-out-email-alert"
}, {
  label: "Absence Email Alert",
  value: "absence-email-alert"
}, {
  label: "Excess of Idle Time",
  value: "high-idle-time"
}];
var idleNotificationIntervalList = [{
  label: "1 hour",
  value: 1
}, {
  label: "2 hours",
  value: 2
}, {
  label: "3 hours",
  value: 3
}, {
  label: "4 hours",
  value: 4
}, {
  label: "5 hours",
  value: 5
}, {
  label: "6 hours",
  value: 6
}];
function changeWeekDayOrder(selectedDays) {
  var weekdayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  var activeDays = selectedDays.split(", ").sort(function (a, b) {
    return weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b);
  });
  var orderedDaysString = activeDays.join(", ");
  return orderedDaysString;
}
var CreateAlertModal = function CreateAlertModal(props) {
  var show = props.show,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    role = props.role,
    organisationTeamAndRole = props.organisationTeamAndRole,
    alertTypeFilter = props.alertTypeFilter,
    timeFilter = props.timeFilter;
  if (!show) {
    return false;
  }
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isAlreadyLoggedIn = _React$useState28[0],
    setIsAlreadyLoggedIn = _React$useState28[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    userList = _useState18[0],
    setUserList = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    teamList = _useState20[0],
    setTeamList = _useState20[1];
  var formikRef = useRef();
  var activeDaysTemp = organisationSettings.workingDays ? organisationSettings.workingDays.split(",").map(function (d) {
    return d.trim();
  }) : [];
  var alertInitialValues = {
    ruleName: alertTypeForAdd[0].label,
    //:mm a
    alertType: alertTypeForAdd[0].value,
    reminderTime: "",
    expectedClockInTime: "",
    expectedClockOutTime: "",
    isAlreadyLoggedIn: false,
    expectedIdleTime: "",
    sendReminderTo: role == "Head" ? "teamMembers" : "everyone",
    deliveryMethod: "email",
    alertSendTo: [userId],
    alertSendToTeam: [],
    activeDays: activeDaysTemp,
    userPreferenceList: [],
    userPreferenceType: "allEmployees",
    idleNotificationInterval: 1,
    startTime: "",
    endTime: ""
  };
  var errorMessage = function errorMessage(errors, touched, name) {
    var error = getIn(errors, name);
    var touch = getIn(touched, name);
    if (error && touch) {
      return /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, error);
    }
    return null;
  };
  var minuteOptions = [5, 10, 15, 20, 30, 45, 60];
  var formats = "h:mm a";
  var _useMutation3 = useMutation(ADD_REAL_TIME_ALERT_NOTIFICATION_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addRealTimeAlertNotification = _useMutation4[0],
    addRealTimeAlertNotificationLoading = _useMutation4[1].loading;
  var onAlertSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var alertType, deliveryMethod, expectedClockInTime, expectedIdleTime, isAlreadyLoggedIn, reminderTime, ruleName, sendReminderTo, alertSendTo, expectedClockOutTime, sendEmailAt, userPreferenceList, userPreferenceType, activeDays, alertSendToTeam, idleNotificationInterval, startTime, endTime, activeDaysString, expectedClockInTimeFormat, expectedClockOutTimeFormat, sendEmailAtTimeFormat, startTimeFormat, endTimeFormat, sendReminderToUserTemp, sendReminderToTeamTemp, variables, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            alertType = values.alertType, deliveryMethod = values.deliveryMethod, expectedClockInTime = values.expectedClockInTime, expectedIdleTime = values.expectedIdleTime, isAlreadyLoggedIn = values.isAlreadyLoggedIn, reminderTime = values.reminderTime, ruleName = values.ruleName, sendReminderTo = values.sendReminderTo, alertSendTo = values.alertSendTo, expectedClockOutTime = values.expectedClockOutTime, sendEmailAt = values.sendEmailAt, userPreferenceList = values.userPreferenceList, userPreferenceType = values.userPreferenceType, activeDays = values.activeDays, alertSendToTeam = values.alertSendToTeam, idleNotificationInterval = values.idleNotificationInterval, startTime = values.startTime, endTime = values.endTime;
            activeDaysString = activeDays.join(", ");
            _context2.next = 4;
            return changeWeekDayOrder(activeDaysString);
          case 4:
            activeDaysString = _context2.sent;
            // let alertSendTo = [];
            // let sendEmailAt = reminderTime;
            expectedClockInTimeFormat = expectedClockInTime ? moment(expectedClockInTime).format("HH:mm A") : null;
            expectedClockOutTimeFormat = expectedClockOutTime ? moment(expectedClockOutTime).format("HH:mm A") : null;
            sendEmailAtTimeFormat = sendEmailAt ? moment(sendEmailAt).format("HH:mm A") : null;
            startTimeFormat = startTime ? moment(startTime).format("HH:mm A") : null;
            endTimeFormat = endTime ? moment(endTime).format("HH:mm A") : null;
            sendReminderToUserTemp = sendReminderTo == "teamMembers" || sendReminderTo == "teamMembers&teamHead" || sendReminderTo == "everyone" || sendReminderTo == "respectiveTeamMembers" ? [] : alertSendTo;
            sendReminderToTeamTemp = sendReminderTo == "teamMembers" || sendReminderTo == "teamMembers&teamHead" || sendReminderTo == "respectiveTeamMembers" ? alertSendToTeam : [];
            variables = {
              alertType: alertType,
              ruleName: ruleName,
              organisationId: organisationId,
              alertSendTo: sendReminderToUserTemp,
              expectedClockInTime: expectedClockInTimeFormat,
              sendEmailAt: sendEmailAtTimeFormat,
              sendReminderTo: sendReminderTo,
              notificationMethod: deliveryMethod,
              userId: userId,
              expectedIdleTime: Number(expectedIdleTime),
              tz: organisationSettings.organisationTimezone,
              expectedClockOutTime: expectedClockOutTimeFormat,
              userPreferenceList: userPreferenceList,
              userPreferenceType: userPreferenceType,
              activeDays: activeDaysString,
              skipAlreadyLoggedIn: isAlreadyLoggedIn,
              alertSendToTeam: sendReminderToTeamTemp,
              idleNotificationInterval: idleNotificationInterval !== null && idleNotificationInterval !== void 0 ? idleNotificationInterval : 0,
              startTime: startTimeFormat,
              endTime: endTimeFormat
            };
            _context2.prev = 13;
            _context2.next = 16;
            return addRealTimeAlertNotification({
              variables: variables,
              update: function update(cache, _ref9) {
                var _data$addRealTimeAler;
                var data = _ref9.data;
                var newItem = data === null || data === void 0 ? void 0 : (_data$addRealTimeAler = data.addRealTimeAlertNotification) === null || _data$addRealTimeAler === void 0 ? void 0 : _data$addRealTimeAler[0];
                if (!newItem) return;
                cache.modify({
                  fields: {
                    listRealTimeAlertNotification: function listRealTimeAlertNotification() {
                      var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                      return [newItem].concat(_toConsumableArray(existing));
                    }
                  }
                });
                cache.modify({
                  fields: {
                    alertRuleHeaderDetails: function alertRuleHeaderDetails(existing) {
                      return _objectSpread(_objectSpread({}, existing), {}, {
                        totalRuleCount: ((existing === null || existing === void 0 ? void 0 : existing.totalRuleCount) || 0) + 1,
                        activeRuleCount: ((existing === null || existing === void 0 ? void 0 : existing.activeRuleCount) || 0) + 1
                      });
                    }
                  }
                });
                if (newItem.sendEmailAt) {
                  var sendEmailAtValue = moment.tz(newItem.sendEmailAt, "hh:mm A", organisationSettings.organisationTimezone).utc().format("HH:mm");
                  cache.modify({
                    fields: {
                      realTimeAlertTimeList: function realTimeAlertTimeList() {
                        var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var alreadyExists = existing.some(function (item) {
                          return item.value === sendEmailAtValue;
                        });
                        if (alreadyExists) return existing;
                        return [].concat(_toConsumableArray(existing), [{
                          label: newItem.sendEmailAt,
                          value: sendEmailAtValue
                        }]);
                      }
                    }
                  });
                }
              }
            });
          case 16:
            response = _context2.sent;
            if (!(!response || !response.data || response.data.addRealTimeAlertNotification == null)) {
              _context2.next = 22;
              break;
            }
            throw new Error("error");
          case 22:
            // setTeamActive
            handleClose();
            toast.success("Alert rule added successfully!");
          case 24:
            _context2.next = 30;
            break;
          case 26:
            _context2.prev = 26;
            _context2.t0 = _context2["catch"](13);
            console.log({
              error: _context2.t0
            });
            toast.error("Error Occured, Try again later!");
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[13, 26]]);
    }));
    return function (_x2, _x3) {
      return _ref8.apply(this, arguments);
    };
  }(), [addRealTimeAlertNotification, addRealTimeAlertNotificationLoading, isAlreadyLoggedIn, alertTypeFilter, timeFilter]);
  var _useLazyQuery7 = useLazyQuery(MEMBER_LIST_FOR_ALERT_QUERY),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getMemberListData = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    memberListData = _useLazyQuery8$.data,
    memberListError = _useLazyQuery8$.error,
    memberListLoading = _useLazyQuery8$.loading;
  var _useLazyQuery9 = useLazyQuery(TEAM_DETAILS_FOR_USER_QUERY),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getTeamListData = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    teamListData = _useLazyQuery10$.data,
    teamListError = _useLazyQuery10$.error,
    teamListLoading = _useLazyQuery10$.loading;
  React.useEffect(function () {
    getMemberListData({
      variables: {
        organisationId: organisationId,
        userId: userId,
        role: role
      },
      skip: !organisationId
    });
    getTeamListData({
      variables: {
        organisationId: organisationId,
        userId: userId
      },
      skip: !organisationId && !userId
    });
  }, []);
  React.useEffect(function () {
    if (memberListData !== null && memberListData !== void 0 && memberListData.memberListForAlert) {
      var _memberListData$membe2;
      var memberData = memberListData === null || memberListData === void 0 ? void 0 : (_memberListData$membe2 = memberListData.memberListForAlert) === null || _memberListData$membe2 === void 0 ? void 0 : _memberListData$membe2.map(function (item) {
        var userId = item.userId,
          displayName = item.displayName;
        return {
          label: displayName,
          value: userId
        };
      });
      setUserList(_toConsumableArray(memberData));
    }
  }, [memberListData]);
  React.useEffect(function () {
    if (teamListData !== null && teamListData !== void 0 && teamListData.teamDetailsForUser) {
      var _teamListData$teamDet;
      var memberData = teamListData === null || teamListData === void 0 ? void 0 : (_teamListData$teamDet = teamListData.teamDetailsForUser) === null || _teamListData$teamDet === void 0 ? void 0 : _teamListData$teamDet.map(function (item) {
        var teamId = item.teamId,
          teamName = item.teamName;
        return {
          label: teamName,
          value: teamId
        };
      });
      setTeamList(_toConsumableArray(memberData));
    }
  }, [teamListData]);
  function disabledClockInReminderMinutes() {
    var length = 60;
    var includeOptions = [0, 15, 30, 45];
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (includeOptions.indexOf(value) < 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  var idleNotificationIntervalListTemp = idleNotificationIntervalList;
  if (organisationId == "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || organisationId == "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" || organisationId == "5da90b00-1205-11ee-99eb-6f59a4034ddc" || organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationId == "1e825600-36a4-11f0-b9ab-593e5e9a3ecc" || organisationId == "0ef0f730-e551-11f0-8a0a-0fb43f8de935") {
    idleNotificationIntervalListTemp = [{
      label: "10 mins",
      value: 10
    }].concat(_toConsumableArray(idleNotificationIntervalListTemp));
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "lg",
    className: "create-new-alert-modal",
    backdrop: "static" // disables outside click close
    ,
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "create-new-alert-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "create-new-alert-modal-title"
  }, "Create New Alert Rule")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "create-new-alert-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRef,
    onSubmit: onAlertSubmit,
    initialValues: alertInitialValues,
    validationSchema: alertSubmitSchema
  }, function (_ref10) {
    var values = _ref10.values,
      errors = _ref10.errors,
      touched = _ref10.touched,
      isSubmitting = _ref10.isSubmitting,
      setFieldError = _ref10.setFieldError,
      setFieldValue = _ref10.setFieldValue,
      setFieldTouched = _ref10.setFieldTouched;
    var ruleNameError = errorMessage(errors, touched, "ruleName");
    var alertTypeError = errorMessage(errors, touched, "alertType");
    var reminderTimeError = errorMessage(errors, touched, "sendEmailAt");
    var expectedClockInTimeError = errorMessage(errors, touched, "expectedClockInTime");
    var alertSendToError = errorMessage(errors, touched, "alertSendTo");
    var alertSendToTeamError = errorMessage(errors, touched, "alertSendToTeam");
    var idleNotificationIntervalError = errorMessage(errors, touched, "idleNotificationInterval");
    var expectedIdleTimeError = errorMessage(errors, touched, "expectedIdleTime");
    var startTimeError = errorMessage(errors, touched, "startTime");
    var endTimeError = errorMessage(errors, touched, "endTime");
    var userPreferenceListError = errorMessage(errors, touched, "userPreferenceList");
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "payroll-settings-edit-label-name"
    }, "Rule Name", /*#__PURE__*/React.createElement("span", {
      "class": "add-employee-modal-form-employee-label-name-required"
    }, " *")), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "payroll-settings-edit-input",
      name: "ruleName",
      type: "text",
      required: true,
      placeholder: "Enter rule name",
      isInvalid: ruleNameError != null
    }), ruleNameError)), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertType"
    }, function (_ref11) {
      var field = _ref11.field,
        form = _ref11.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Alert Type", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertTypeError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: alertTypeForAdd.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(e) {
          setFieldValue("alertType", e.value);
          setFieldValue("ruleName", e.label);
          var reminderValue = e.value == "clock-in-reminder" && role == "Admin" ? "everyone" : e.value != "clock-in-reminder" && role == "Admin" ? "admin" : e.value != "clock-in-reminder" && role == "Admin" ? "admin" : e.value == "late-clock-in-email-alert" && role == "Head" ? "respectiveTeamMembers" : e.value == "absence-email-alert" && role == "Head" ? "selectivePersons" : e.value == "early-clock-out-email-alert" || e.value == "high-idle-time" ? "respectiveTeamMembers" : null;
          setFieldValue("sendReminderTo", reminderValue);
        },
        options: alertTypeForAdd
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, values.alertType == null || values.alertType == "clock-in-reminder" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-clock-in-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-clock-in-reminder-wrapper-text1"
    }, "Clock-in Reminder Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-clock-in-reminder-wrapper-text2"
    }, "Configure reminder time and recipient settings"), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Set the expected clock-in time for your team members based on your organization’s timezone (e.g., 09:00 AM).")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Send Reminder At", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Set the time to send the email notification prompting team members to clock in.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          setFieldTouched("sendEmailAt", true);
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Reminder Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) < moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Reminder time must be before the expected clock-in time.") : null);
    }), /*#__PURE__*/React.createElement("div", {
      className: "alert-tab-alert-rule-table-status-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "idle-alert-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-control custom-switch idle-alert-switch"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "custom-control-input",
      id: "customSwitch",
      checked: isAlreadyLoggedIn,
      onChange: function onChange(e) {
        // localStorage?.setItem?.("timezone", isToggled ? "userTimezone" : "organisationTimezone");
        setIsAlreadyLoggedIn(!isAlreadyLoggedIn);
        setFieldValue("isAlreadyLoggedIn", !isAlreadyLoggedIn);
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "custom-control-label",
      htmlFor: "customSwitch"
    })), /*#__PURE__*/React.createElement("h6", {
      className: "payroll-settings-edit-label-name"
    }, " Skip if they have already logged-in")))) : values.alertType == "late-clock-in-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-late-clock-in-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-late-clock-in-reminder-wrapper-text1"
    }, "Late Clock-in Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-late-clock-in-reminder-wrapper-text2"
    }, "Set the expected clock-in time and the cut-off time for sending late clock-in alerts. Employees who clock-in between these times will be included in the email notification."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Normal start time for employees.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time & Clock-in Cut-Off Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", null, "Time to send the late clock-in report."))
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Email notification time must be after the expected clock-in time.") : null);
    })) : values.alertType == "early-clock-out-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-early-clock-out-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-early-clock-out-reminder-wrapper-text1"
    }, "Early Clock-out Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-early-clock-out-reminder-wrapper-text2"
    }, "Configure early clock-out detection and admin notification"), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockOutTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-out Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Normal end time for employees.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      }))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockOutTime",
        value: values.expectedClockOutTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockOutTime", e);
        },
        placeholder: "Expected Clock-out Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time (time after early clock-out)", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", null, "Time to send the early clock-out report."))
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      }))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockOutTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Email notification time must be after the expected clock-out time.") : null);
    })) : values.alertType == "absence-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-absence-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-absence-reminder-wrapper-text1"
    }, "Absence Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-absence-reminder-wrapper-text2"
    }, "Configure automatic alerts for employees who have not clocked in by the set time."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Usual start time for employees. If they haven’t clocked in by this time, they may be marked as absent")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Time to send the absence report to admins listing employees who have not clocked in yet.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Time to send the absence report to admins listing employees who have not clocked in yet.") : null);
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-idle-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-idle-reminder-wrapper-text1"
    }, "Excess of Idle Time Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-idle-reminder-wrapper-text2"
    }, "Anyone who exceeds the configured idle time threshold will be included in the excess idle time alert."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedIdleTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Allowed Idle Time (in minutes)", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedIdleTimeError, /*#__PURE__*/React.createElement(Field, {
        as: "select",
        name: "expectedIdleTime",
        className: "form-control payroll-settings-edit-input"
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "Allowed Idle Time"), minuteOptions.map(function (min) {
        return /*#__PURE__*/React.createElement("option", {
          key: min,
          value: min
        }, min);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "idleNotificationInterval"
    }, function (_ref12) {
      var field = _ref12.field,
        form = _ref12.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "How frequently (in hours) would you like to receive alerts for excess idle time?", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), idleNotificationIntervalError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: idleNotificationIntervalListTemp.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(e) {
          setFieldValue("idleNotificationInterval", e.value);
        },
        options: idleNotificationIntervalListTemp
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-idle-reminder-wrapper create-alert-idle-reminder-notification-window-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-idle-reminder-wrapper-text1"
    }, "Set Notification Time Range"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-idle-reminder-wrapper-text2"
    }, "Set the time range during which you want to receive idle time alerts."), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Choose when the alerting should begin.", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), startTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: values.startTime,
        onChange: function onChange(e) {
          setFieldValue("startTime", e);

          // startOnChange(e, setFieldValue);
          // setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })), /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-sub-label"
      }, "When to start sending notifications"));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Choose when the alerting should stop.", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), endTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: values.endTime,
        onChange: function onChange(e) {
          setFieldValue("endTime", e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-sub-label"
      }, "When to stop sending notifications"), values.startTime && values.endTime && moment(values.startTime).format("A") == "PM" && moment(values.endTime).format("A") == "AM" ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "End time cannot be earlier than the start time. Please select times within the same day.") : values.startTime && values.endTime && moment(values.endTime) <= moment(values.startTime) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "End time must be greater than the start time.") : null);
    }))))))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4 my-3"
    }, /*#__PURE__*/React.createElement(ActiveDaysSelector, {
      name: "activeDays"
    }), errors.activeDays && touched.activeDays && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-1 ml-3"
    }, errors.activeDays))), values.alertType != "clock-in-reminder" ? /*#__PURE__*/React.createElement("div", {
      className: "p-3 my-3 border create-alert-clock-in-reminder-report-recipients-notification-wrapper"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-success d-block create-alert-clock-in-reminder-report-recipients-notification-wrapper-text1"
    }, "Employees to Include in Report"), /*#__PURE__*/React.createElement("p", {
      className: "mb-2 text-success create-alert-clock-in-reminder-report-recipients-notification-wrapper-text2"
    }, values.alertType == "late-clock-in-email-alert" ? "Choose whether to include all late clock-ins or only selected employees in the email report." : values.alertType == "absence-email-alert" ? "Choose whether to include all absents or only selected employees in the email report." : values.alertType == "early-clock-out-email-alert" ? "Choose whether to include all clock-outs or only selected employees in the email report." : values.alertType == "high-idle-time" ? "Choose whether to include all idles or only selected employees in the email report." : null), /*#__PURE__*/React.createElement(Form.Group, {
      className: "create-alert-clock-in-reminder-employee-include-report-wrapper"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: values.alertType == "late-clock-in-email-alert" ? "Include all late clock-ins" : values.alertType == "absence-email-alert" ? "Include all absents" : values.alertType == "early-clock-out-email-alert" ? "Include all early clock-outs" : "Include all high idle time records",
      value: "allEmployees",
      name: "userPreferenceType",
      id: "include-all-late-clock-ins",
      className: "create-new-alert-radion-button"
    }), " ", /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: values.alertType == "late-clock-in-email-alert" ? "Include selected employees' late clock-in only" : values.alertType == "absence-email-alert" ? "Include selected employees' absent only" : values.alertType == "early-clock-out-email-alert" ? "Include selected employees’ early clock-outs only" : "Include selected employees’ high idle time records only",
      value: "selectedEmployees",
      name: "userPreferenceType",
      id: "include-late-clock-ins-for-selected-employees-only",
      className: "create-new-alert-radion-button"
    })), values.userPreferenceType == "selectedEmployees" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "userPreferenceList"
    }, function (_ref13) {
      var field = _ref13.field,
        form = _ref13.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), userPreferenceListError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("userPreferenceList", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("userPreferenceList", []);
          }
        },
        options: userList,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "p-3 my-3 border create-alert-clock-in-reminder-notification-wrapper"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-success d-block create-alert-clock-in-reminder-notification-wrapper-text1"
    }, "Notification Recipients"), /*#__PURE__*/React.createElement("p", {
      className: "mb-2 text-success create-alert-clock-in-reminder-notification-wrapper-text2"
    }, "Choose who should receive these notifications"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-clock-in-reminder-notification-wrapper-text3"
    }, "Send ", values.alertType == "clock-in-reminder" ? "reminder" : "notification", " to:"), /*#__PURE__*/React.createElement(Form.Group, null, values.alertType == "clock-in-reminder" ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to everyone",
      value: "everyone",
      name: "sendReminderTo",
      id: "send-reminder-to-everyone",
      className: "create-new-alert-radion-button"
    }) : null, " ", /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to team members only",
      value: "teamMembers",
      name: "sendReminderTo",
      id: "send-reminder-to-team-members-only",
      className: "create-new-alert-radion-button"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to team members and team heads only",
      value: "teamMembers&teamHead",
      name: "sendReminderTo",
      id: "send-reminder-to-team-members-and-team-heads-only",
      className: "create-new-alert-radion-button"
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref14) {
      var field = _ref14.field,
        form = _ref14.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)) : values.alertType == "absence-email-alert" ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to admin(s)",
      value: "admin",
      name: "sendReminderTo",
      id: "send-to-admin",
      className: "create-new-alert-radion-button"
    }) : null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref15) {
      var field = _ref15.field,
        form = _ref15.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)) : /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to admin(s)",
      value: "admin",
      name: "sendReminderTo",
      id: "send-to-admin",
      className: "create-new-alert-radion-button"
    }) : null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to respective team members",
      value: "respectiveTeamMembers",
      name: "sendReminderTo",
      id: "send-to-respective-members",
      className: "create-new-alert-radion-button"
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref16) {
      var field = _ref16.field,
        form = _ref16.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Button, {
      variant: "dark",
      className: "create-alert-rule-button",
      type: "submit",
      disabled: addRealTimeAlertNotificationLoading || values.alertType == "clock-in-reminder" && values.sendEmailAt && moment(values.expectedClockInTime) < moment(values.sendEmailAt) || values.alertType != "clock-in-reminder" && values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) || values.alertType == "high-idle-time" && values.startTime && values.endTime && moment(values.endTime) <= moment(values.startTime)
    }, addRealTimeAlertNotificationLoading ? "Loading..." : "Create Alert Rule")));
  })));
};
var ActiveDaysSelector = function ActiveDaysSelector(_ref17) {
  var name = _ref17.name;
  var days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  return /*#__PURE__*/React.createElement(FieldArray, {
    name: name
  }, function (_ref18) {
    var push = _ref18.push,
      remove = _ref18.remove,
      form = _ref18.form;
    var selectedDays = form.values[name] || [];
    var handleChange = function handleChange(day) {
      if (selectedDays.includes(day)) {
        var index = selectedDays.indexOf(day);
        remove(index);
      } else {
        push(day);
      }
    };
    return /*#__PURE__*/React.createElement(Card, {
      className: "p-3 create-alert-type-active-days-card"
    }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Applicable days")), /*#__PURE__*/React.createElement("p", {
      className: "create-alert-type-active-days-sub-title"
    }, "Select the days when this alert should be triggered"), /*#__PURE__*/React.createElement(Form, {
      className: "d-flex flex-wrap align-items-center create-alert-type-active-days-form-group"
    }, days.map(function (day) {
      return /*#__PURE__*/React.createElement(Form.Check, {
        key: day,
        type: "checkbox",
        id: "check-".concat(day),
        label: day,
        checked: selectedDays.includes(day),
        onChange: function onChange() {
          return handleChange(day);
        },
        className: "mr-3 mb-2 create-alert-type-active-days-form-check"
      });
    })), selectedDays.length === 0 && /*#__PURE__*/React.createElement(Alert, {
      variant: "warning",
      className: "mt-3 d-flex align-items-center create-alert-type-active-days-no-days-selected"
    }, /*#__PURE__*/React.createElement(FaExclamationTriangle, {
      className: "mr-2"
    }), "No days selected \u2013 alert will not trigger"));
  });
};
var ViewAlertModal = function ViewAlertModal(props) {
  var show = props.show,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    role = props.role;
  if (!show) {
    return false;
  }
  var sendEmailAt = show.sendEmailAt,
    expectedClockInTime = show.expectedClockInTime,
    alertTypeLabel = show.alertTypeLabel,
    iconBackgroundColor = show.iconBackgroundColor,
    icon = show.icon,
    status = show.status,
    ruleName = show.ruleName,
    addedAt = show.addedAt,
    activeDays = show.activeDays,
    sendReminderTo = show.sendReminderTo,
    sendTo = show.sendTo,
    createdBy = show.createdBy,
    userPreferenceList = show.userPreferenceList,
    sentToTeam = show.sentToTeam,
    alertType = show.alertType,
    idleNotificationInterval = show.idleNotificationInterval,
    startTime = show.startTime,
    endTime = show.endTime,
    expectedClockOutTime = show.expectedClockOutTime,
    expectedIdleTime = show.expectedIdleTime;
  var sendToUsers = sendTo ? sendTo.map(function (user) {
    return user.displayName;
  }) : "";
  var sendToTeams = sentToTeam ? sentToTeam.map(function (team) {
    return team.teamName;
  }) : "";
  var userPreferenceListUsers = userPreferenceList ? userPreferenceList.map(function (user) {
    return user.displayName;
  }) : "";
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "lg",
    className: "view-new-alert-modal",
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "view-new-alert-modal-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center view-new-alert-modal-header-name-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert-tab-alert-rule-table-icon-wrapper",
    style: {
      backgroundColor: iconBackgroundColor
    }
  }, icon), /*#__PURE__*/React.createElement("h5", {
    className: "mb-0 font-weight-bold view-new-alert-modal-header-text view-new-alert-modal-col-type-value-header view-alert-tab-alert-rule-table-rule-name"
  }, ruleName))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "p-4 view-new-alert-modal-body"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Rule Name"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, ruleName)), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Type"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, alertTypeLabel))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Status"), /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    variant: status ? "success" : "secondary",
    className: "view-new-alert-modal-col-status-value"
  }, status ? "Active" : "Inactive")), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Applicable days"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, activeDays))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, alertType == "early-clock-out-email-alert" ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Expected Clock-Out Time"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, expectedClockOutTime)) : alertType == "high-idle-time" ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Allowed Idle Time"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, expectedIdleTime, expectedIdleTime > 1 ? " minutes" : " minute")) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Expected Clock-in Time"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, expectedClockInTime))), /*#__PURE__*/React.createElement(Col, null, alertType == "high-idle-time" ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Notification Interval"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, idleNotificationInterval, idleNotificationInterval == 10 ? " mins" : idleNotificationInterval > 1 ? " hours" : " hour")) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, " Email Notification Time"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, sendEmailAt)))), alertType == "high-idle-time" ? /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Notification will be sent from"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, startTime)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Notification will be sent till"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, endTime))) : null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Created At"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, moment(Number(addedAt)).format("DD MMM, YYYY hh:mm A"))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Created By"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, createdBy))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Send ", alertType == "clock-in-reminder" ? "Reminder" : "Notification", " To"), /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-value"
  }, " ", sendReminderTo == "everyone" ? "Everyone" : sendReminderTo == "teamMembers" ? "Members" : sendReminderTo == "teamMembers&teamHead" ? "Members & Head" : sendReminderTo == "admin" ? "Admin" : sendReminderTo == "respectiveTeamMembers" ? "Respective Members" : sendToUsers.length ? sendToUsers === null || sendToUsers === void 0 ? void 0 : sendToUsers.map(function (user, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "view-new-alert-modal-col-type-value"
    }, user);
  }) : sendToTeams.length ? sendToTeams === null || sendToTeams === void 0 ? void 0 : sendToTeams.map(function (team, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "view-new-alert-modal-col-type-value"
    }, team);
  }) : "-")), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, alertType == "late-clock-in-email-alert" || alertType == "absence-email-alert" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "view-new-alert-modal-col-type-label"
  }, "Employees to Include in Report"), userPreferenceListUsers.length ? /*#__PURE__*/React.createElement(React.Fragment, null, userPreferenceListUsers === null || userPreferenceListUsers === void 0 ? void 0 : userPreferenceListUsers.map(function (user, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "view-new-alert-modal-col-type-value"
    }, user);
  })) : alertType == "late-clock-in-email-alert" ? "All late clock-in employees" : alertType == "absence-email-alert" ? "All absent employees" : "All Employees") : null))));
};
var EditAlertModal = function EditAlertModal(props) {
  var show = props.show,
    handleClose = props.handleClose,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings,
    role = props.role;
  if (!show) {
    return false;
  }
  var sendEmailAt = show.sendEmailAt,
    expectedClockInTime = show.expectedClockInTime,
    expectedClockOutTime = show.expectedClockOutTime,
    startTime = show.startTime,
    endTime = show.endTime;
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    isAlreadyLoggedIn = _React$useState30[0],
    setIsAlreadyLoggedIn = _React$useState30[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    userList = _useState22[0],
    setUserList = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    teamList = _useState24[0],
    setTeamList = _useState24[1];
  var formikRefEdit = useRef();
  var dateTemp = moment().format("DD/MM/YYYY");
  var expectedClockInTimeValue = expectedClockInTime ? moment(dateTemp + " " + expectedClockInTime, "DD/MM/YYYY h:mm a") : "";
  var expectedClockOutTimeValue = expectedClockOutTime ? moment(dateTemp + " " + expectedClockOutTime, "DD/MM/YYYY h:mm a") : "";
  var sendEmailAtValue = moment(dateTemp + " " + sendEmailAt, "DD/MM/YYYY h:mm a");
  var startTimeValue = moment(dateTemp + " " + startTime, "DD/MM/YYYY h:mm a");
  var endTimeValue = moment(dateTemp + " " + endTime, "DD/MM/YYYY h:mm a");
  var activeDaysTemp = show.activeDays ? show.activeDays.split(", ").map(function (day) {
    return day.trim();
  }) : [];
  React.useEffect(function () {
    if (show) {
      setIsAlreadyLoggedIn(show.skipAlreadyLoggedIn == true ? true : false);
    }
  }, [show]);
  var alertInitialValues = {
    ruleName: show.ruleName,
    //:mm a
    alertType: show.alertType,
    sendEmailAt: show.sendEmailAt ? sendEmailAtValue : "",
    expectedClockInTime: show.expectedClockInTime ? expectedClockInTimeValue : "",
    isAlreadyLoggedIn: show.skipAlreadyLoggedIn == true ? true : false,
    expectedIdleTime: show.expectedIdleTime,
    sendReminderTo: show.sendReminderTo,
    deliveryMethod: show.notificationMethod,
    alertSendTo: show.sendTo ? show.sendTo.map(function (user) {
      return user.userId;
    }) : [],
    expectedClockOutTime: show.expectedClockOutTime ? expectedClockOutTimeValue : "",
    userPreferenceList: show.userPreferenceList ? show.userPreferenceList.map(function (user) {
      return user.userId;
    }) : [],
    userPreferenceType: show.userPreferenceType ? show.userPreferenceType : "",
    activeDays: activeDaysTemp,
    alertSendToTeam: show.sentToTeam ? show.sentToTeam.map(function (team) {
      return team.teamId;
    }) : [],
    idleNotificationInterval: show.idleNotificationInterval ? show.idleNotificationInterval : null,
    startTime: show.startTime ? startTimeValue : "",
    endTime: show.endTime ? endTimeValue : ""
  };
  var errorMessage = function errorMessage(errors, touched, name) {
    var error = getIn(errors, name);
    var touch = getIn(touched, name);
    if (error && touch) {
      return /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }, error);
    }
    return null;
  };
  var minuteOptions = [5, 10, 15, 20, 30, 45, 60];
  var formats = "h:mm a";
  var _useMutation5 = useMutation(EDIT_REAL_TIME_ALERT_NOTIFICATION_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    editRealTimeAlertNotification = _useMutation6[0],
    editRealTimeAlertNotificationLoading = _useMutation6[1].loading;
  var _useLazyQuery11 = useLazyQuery(TEAM_DETAILS_FOR_USER_QUERY),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getTeamListData = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    teamListData = _useLazyQuery12$.data,
    teamListError = _useLazyQuery12$.error,
    teamListLoading = _useLazyQuery12$.loading;
  var onAlertEditSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(values, actions) {
      var alertType, deliveryMethod, expectedClockInTime, expectedIdleTime, isAlreadyLoggedIn, sendEmailAt, ruleName, sendReminderTo, alertSendTo, expectedClockOutTime, userPreferenceList, userPreferenceType, activeDays, alertSendToTeam, startTime, endTime, idleNotificationInterval, expectedClockInTimeFormat, expectedClockOutTimeFormat, sendEmailAtTimeFormat, startTimeFormat, endTimeFormat, activeDaysString, variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            alertType = values.alertType, deliveryMethod = values.deliveryMethod, expectedClockInTime = values.expectedClockInTime, expectedIdleTime = values.expectedIdleTime, isAlreadyLoggedIn = values.isAlreadyLoggedIn, sendEmailAt = values.sendEmailAt, ruleName = values.ruleName, sendReminderTo = values.sendReminderTo, alertSendTo = values.alertSendTo, expectedClockOutTime = values.expectedClockOutTime, userPreferenceList = values.userPreferenceList, userPreferenceType = values.userPreferenceType, activeDays = values.activeDays, alertSendToTeam = values.alertSendToTeam, startTime = values.startTime, endTime = values.endTime, idleNotificationInterval = values.idleNotificationInterval;
            expectedClockInTimeFormat = expectedClockInTime ? moment(expectedClockInTime).format("HH:mm A") : null;
            expectedClockOutTimeFormat = expectedClockOutTime ? moment(expectedClockOutTime).format("HH:mm A") : null;
            sendEmailAtTimeFormat = sendEmailAt ? moment(sendEmailAt).format("HH:mm A") : null;
            startTimeFormat = startTime ? moment(startTime).format("HH:mm A") : null;
            endTimeFormat = endTime ? moment(endTime).format("HH:mm A") : null;
            activeDaysString = activeDays.join(", ");
            _context3.next = 9;
            return changeWeekDayOrder(activeDaysString);
          case 9:
            activeDaysString = _context3.sent;
            variables = {
              alertId: show.alertId,
              alertType: alertType,
              ruleName: ruleName,
              organisationId: organisationId,
              alertSendTo: alertSendTo,
              expectedClockInTime: expectedClockInTimeFormat,
              sendEmailAt: sendEmailAtTimeFormat,
              sendReminderTo: sendReminderTo,
              notificationMethod: deliveryMethod,
              userId: userId,
              expectedIdleTime: Number(expectedIdleTime),
              tz: organisationSettings.organisationTimezone,
              expectedClockOutTime: expectedClockOutTimeFormat,
              userPreferenceList: userPreferenceList,
              userPreferenceType: userPreferenceType,
              activeDays: activeDaysString,
              skipAlreadyLoggedIn: isAlreadyLoggedIn,
              alertSendToTeam: alertSendToTeam,
              startTime: startTimeFormat,
              endTime: endTimeFormat,
              idleNotificationInterval: idleNotificationInterval
            };
            _context3.prev = 11;
            _context3.next = 14;
            return editRealTimeAlertNotification({
              variables: variables,
              update: function update(cache, _ref20) {
                var _data$editRealTimeAle;
                var data = _ref20.data;
                var updatedItem = data === null || data === void 0 ? void 0 : (_data$editRealTimeAle = data.editRealTimeAlertNotification) === null || _data$editRealTimeAle === void 0 ? void 0 : _data$editRealTimeAle[0];
                if (!updatedItem) return;
                cache.modify({
                  fields: {
                    listRealTimeAlertNotification: function listRealTimeAlertNotification() {
                      var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                      return existing.map(function (item) {
                        return item.alertId === updatedItem.alertId ? _objectSpread(_objectSpread({}, item), updatedItem) : item;
                      });
                    }
                  }
                });
                if (updatedItem.sendEmailAt) {
                  var _sendEmailAtValue = moment.tz(updatedItem.sendEmailAt, "hh:mm A", organisationSettings.organisationTimezone).utc().format("HH:mm");
                  cache.modify({
                    fields: {
                      realTimeAlertTimeList: function realTimeAlertTimeList() {
                        var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var alreadyExists = existing.some(function (item) {
                          return item.value === _sendEmailAtValue;
                        });
                        if (alreadyExists) return existing;
                        return [].concat(_toConsumableArray(existing), [{
                          label: updatedItem.sendEmailAt,
                          value: _sendEmailAtValue
                        }]);
                      }
                    }
                  });
                }
              }
            });
          case 14:
            response = _context3.sent;
            if (!(!response || !response.data || response.data.editRealTimeAlertNotification == null)) {
              _context3.next = 20;
              break;
            }
            throw new Error("error");
          case 20:
            // setTeamActive
            handleClose();
            toast.success("Alert rule added successfully!");
          case 22:
            _context3.next = 27;
            break;
          case 24:
            _context3.prev = 24;
            _context3.t0 = _context3["catch"](11);
            // console.log({ error });
            toast.error("Error Occured, Try again later!");
          case 27:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[11, 24]]);
    }));
    return function (_x4, _x5) {
      return _ref19.apply(this, arguments);
    };
  }(), [editRealTimeAlertNotification, editRealTimeAlertNotificationLoading, show]);
  var _useLazyQuery13 = useLazyQuery(MEMBER_LIST_FOR_ALERT_QUERY),
    _useLazyQuery14 = _slicedToArray(_useLazyQuery13, 2),
    getMemberListData = _useLazyQuery14[0],
    _useLazyQuery14$ = _useLazyQuery14[1],
    memberListData = _useLazyQuery14$.data,
    memberListError = _useLazyQuery14$.error,
    memberListLoading = _useLazyQuery14$.loading;
  React.useEffect(function () {
    getMemberListData({
      variables: {
        organisationId: organisationId,
        userId: userId,
        role: role
      },
      skip: !organisationId
    });
    getTeamListData({
      variables: {
        organisationId: organisationId,
        userId: userId
      },
      skip: !organisationId && !userId
    });
  }, []);
  React.useEffect(function () {
    if (memberListData !== null && memberListData !== void 0 && memberListData.memberListForAlert) {
      var _memberListData$membe3;
      var memberData = memberListData === null || memberListData === void 0 ? void 0 : (_memberListData$membe3 = memberListData.memberListForAlert) === null || _memberListData$membe3 === void 0 ? void 0 : _memberListData$membe3.map(function (item) {
        var userId = item.userId,
          displayName = item.displayName;
        return {
          label: displayName,
          value: userId
        };
      });
      setUserList(_toConsumableArray(memberData));
    }
  }, [memberListData]);
  React.useEffect(function () {
    if (teamListData !== null && teamListData !== void 0 && teamListData.teamDetailsForUser) {
      var _teamListData$teamDet2;
      var memberData = teamListData === null || teamListData === void 0 ? void 0 : (_teamListData$teamDet2 = teamListData.teamDetailsForUser) === null || _teamListData$teamDet2 === void 0 ? void 0 : _teamListData$teamDet2.map(function (item) {
        var teamId = item.teamId,
          teamName = item.teamName;
        return {
          label: teamName,
          value: teamId
        };
      });
      setTeamList(_toConsumableArray(memberData));
    }
  }, [teamListData]);
  function disabledClockInReminderMinutes() {
    var length = 60;
    var includeOptions = [0, 15, 30, 45];
    var arr = [];
    for (var value = 0; value < length; value++) {
      if (includeOptions.indexOf(value) < 0) {
        arr.push(value);
      }
    }
    return arr;
  }
  var idleNotificationIntervalListTemp = idleNotificationIntervalList;
  if (organisationId == "0b05daf0-1a59-11f0-ab0d-8dc7aeb69888" || organisationId == "35fcc020-e2ec-11ee-9c92-a7c3dd681c18" || organisationId == "5da90b00-1205-11ee-99eb-6f59a4034ddc" || organisationId == "f2c9e240-4e71-11eb-9784-794f853f90e2" || organisationId == "1e825600-36a4-11f0-b9ab-593e5e9a3ecc" || organisationId == "0ef0f730-e551-11f0-8a0a-0fb43f8de935") {
    idleNotificationIntervalListTemp = [{
      label: "10 mins",
      value: 10
    }].concat(_toConsumableArray(idleNotificationIntervalListTemp));
  }
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleClose,
    centered: true,
    size: "lg",
    className: "create-new-alert-modal",
    backdrop: "static" // disables outside click close
    ,
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "create-new-alert-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "create-new-alert-modal-title"
  }, "Edit Alert Rule")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "create-new-alert-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    innerRef: formikRefEdit,
    onSubmit: onAlertEditSubmit,
    initialValues: alertInitialValues,
    validationSchema: alertSubmitSchema
  }, function (_ref21) {
    var values = _ref21.values,
      errors = _ref21.errors,
      touched = _ref21.touched,
      isSubmitting = _ref21.isSubmitting,
      setFieldError = _ref21.setFieldError,
      setFieldValue = _ref21.setFieldValue;
    var ruleNameError = errorMessage(errors, touched, "ruleName");
    var alertTypeError = errorMessage(errors, touched, "alertType");
    var reminderTimeError = errorMessage(errors, touched, "sendEmailAt");
    var expectedClockInTimeError = errorMessage(errors, touched, "expectedClockInTime");
    var alertSendToError = errorMessage(errors, touched, "alertSendTo");
    var alertSendToTeamError = errorMessage(errors, touched, "alertSendToTeam");
    var idleNotificationIntervalError = errorMessage(errors, touched, "idleNotificationInterval");
    var expectedIdleTimeError = errorMessage(errors, touched, "expectedIdleTime");
    var startTimeError = errorMessage(errors, touched, "startTime");
    var endTimeError = errorMessage(errors, touched, "endTime");
    var userPreferenceListError = errorMessage(errors, touched, "userPreferenceList");
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
      className: "payroll-settings-edit-label-name"
    }, "Rule Name", /*#__PURE__*/React.createElement("span", {
      "class": "add-employee-modal-form-employee-label-name-required"
    }, " *")), /*#__PURE__*/React.createElement(Field, {
      as: Form.Control,
      className: "payroll-settings-edit-input",
      name: "ruleName",
      type: "text",
      required: true,
      placeholder: "Enter rule name",
      isInvalid: ruleNameError != null
    }), ruleNameError))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, values.alertType == null || values.alertType == "clock-in-reminder" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-clock-in-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-clock-in-reminder-wrapper-text1"
    }, "Clock-in Reminder Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-clock-in-reminder-wrapper-text2"
    }, "Configure reminder time and recipient settings"), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Set the expected clock-in time for your team members based on your organization’s timezone (e.g., 09:00 AM).")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Send Reminder At", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Set the time to send the email notification prompting team members to clock in.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
          setFieldTouched("sendEmailAt", true);
        },
        placeholder: "Reminder Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) < moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Reminder time must be before the expected clock-in time.") : null);
    }), /*#__PURE__*/React.createElement("div", {
      className: "alert-tab-alert-rule-table-status-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "idle-alert-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-control custom-switch idle-alert-switch"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "custom-control-input",
      id: "customSwitch",
      checked: isAlreadyLoggedIn,
      onChange: function onChange(e) {
        // localStorage?.setItem?.("timezone", isToggled ? "userTimezone" : "organisationTimezone");
        setIsAlreadyLoggedIn(!isAlreadyLoggedIn);
        setFieldValue("isAlreadyLoggedIn", !isAlreadyLoggedIn);
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "custom-control-label",
      htmlFor: "customSwitch"
    })), /*#__PURE__*/React.createElement("h6", {
      className: "payroll-settings-edit-label-name"
    }, " Skip if they have already logged-in")))) : values.alertType == "late-clock-in-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-late-clock-in-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-late-clock-in-reminder-wrapper-text1"
    }, "Late Clock-in Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-late-clock-in-reminder-wrapper-text2"
    }, "Set the expected clock-in time and the cut-off time for sending late clock-in alerts.Employees who clock-in between these times will be included in the email notification."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Normal start time for employees.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time & Clock-in Cut-Off Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Time to send the late clock-in report to admins.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Email notification time must be after the expected clock-in time.") : null);
    })) : values.alertType == "early-clock-out-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-early-clock-out-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-early-clock-out-reminder-wrapper-text1"
    }, "Early Clock-out Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-early-clock-out-reminder-wrapper-text2"
    }, "Configure early clock-out detection and admin notification"), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockOutTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-out Time"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockOutTime",
        value: values.expectedClockOutTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockOutTime", e);
        },
        placeholder: "Expected Clock-out Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time (time after early clock-out)", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, /*#__PURE__*/React.createElement("div", null, "Time to send the early clock-out report."))
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      }))), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error"
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockOutTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Email notification time must be after the expected clock-out time.") : null);
    })) : values.alertType == "absence-email-alert" ? /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-absence-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-absence-reminder-wrapper-text1"
    }, "Absence Alert Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-absence-reminder-wrapper-text2"
    }, "Configure automatic alerts for employees who have not clocked in by the set time."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedClockInTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Expected Clock-in Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Usual start time for employees. If they haven’t clocked in by this time, they may be marked as absent.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), expectedClockInTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "expectedClockInTime",
        value: values.expectedClockInTime,
        onChange: function onChange(e) {
          setFieldValue("expectedClockInTime", e);
        },
        placeholder: "Expected Clock-in Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "sendEmailAt"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Email Notification Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
        rootClose: true,
        placement: "top",
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: "tooltip-bottom",
          className: "project-tooltip-start"
        }, "Time to send the absence report to admins listing employees who have not clocked in yet.")
      }, /*#__PURE__*/React.createElement(MdInfoOutline, {
        className: "create-alert-info-icon"
      })), /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), reminderTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "sendEmailAt",
        value: values.sendEmailAt,
        onChange: function onChange(e) {
          var time = e;
          var mins = moment(e).format("mm");
          if (mins > 0 && mins < 15) {
            time = moment(e).minute(0);
          } else if (mins > 15 && mins < 30) {
            time = moment(e).minute(15);
          } else if (mins > 30 && mins < 45) {
            time = moment(e).minute(30);
          } else if (mins > 45 && mins < 60) {
            time = moment(e).minute(45);
          }
          setFieldValue("sendEmailAt", time);
        },
        placeholder: "Send Email At",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true,
        disabledMinutes: disabledClockInReminderMinutes,
        hideDisabledOptions: true
      })), values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "Email notification time must be after the expected clock-in time.") : null);
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-idle-reminder-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-idle-reminder-wrapper-text1"
    }, "Excess of Idle Time Settings"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-idle-reminder-wrapper-text2"
    }, "Anyone who exceeds the configured idle time threshold will be included in the excess idle time alert."), /*#__PURE__*/React.createElement(Field, {
      name: "expectedIdleTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Allowed Idle Time (in minutes)"), expectedIdleTimeError, /*#__PURE__*/React.createElement(Field, {
        as: "select",
        name: "expectedIdleTime",
        className: "form-control payroll-settings-edit-input"
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "Allowed Idle Time"), minuteOptions.map(function (min) {
        return /*#__PURE__*/React.createElement("option", {
          key: min,
          value: min
        }, min);
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "idleNotificationInterval"
    }, function (_ref22) {
      var field = _ref22.field,
        form = _ref22.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "How frequently (in hours) would you like to receive alerts for excess idle time?", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), idleNotificationIntervalError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: idleNotificationIntervalListTemp.filter(function (option) {
          return field.value == option.value;
        }),
        onChange: function onChange(e) {
          setFieldValue("idleNotificationInterval", e.value);
        },
        options: idleNotificationIntervalListTemp
        //defaultMenuIsOpen={true}
        ,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper create-alert-idle-reminder-wrapper create-alert-idle-reminder-notification-window-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text1 create-alert-idle-reminder-wrapper-text1"
    }, "Set Notification Time Range"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-type-wrapper-text2 create-alert-idle-reminder-wrapper-text2"
    }, "Set the time range during which you want to receive idle time alerts."), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "startTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Choose when the alerting should begin."), startTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "startTime",
        value: values.startTime,
        onChange: function onChange(e) {
          setFieldValue("startTime", e);

          // startOnChange(e, setFieldValue);
          // setStartTimeTemp(e);
        },
        placeholder: "Start Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
        // disabledHours={disabledStartTimeHours}
        // disabledMinutes={disabledStartTimeMinutes}
      })), /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-sub-label"
      }, "When to start sending notifications"));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 6,
      sm: 6,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "endTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Choose when the alerting should stop."), endTimeError, /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-div"
      }, /*#__PURE__*/React.createElement(TimePicker, {
        showSecond: false,
        name: "endTime",
        value: values.endTime,
        onChange: function onChange(e) {
          setFieldValue("endTime", e);
        },
        placeholder: "End Time",
        format: formats,
        use12Hours: true,
        inputIcon: undefined,
        clearIcon: null,
        inputReadOnly: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "create-alert-clock-in-reminder-time-sub-label"
      }, "When to stop sending notifications"), values.startTime && values.endTime && moment(values.endTime) <= moment(values.startTime) ? /*#__PURE__*/React.createElement("div", {
        className: "alert-tab-alert-rule-table-send-email-at-error"
      }, "End time must be greater than Start time.") : null);
    }))))))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4 my-3"
    }, /*#__PURE__*/React.createElement(ActiveDaysSelector, {
      name: "activeDays"
    }), errors.activeDays && touched.activeDays && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-1 ml-3"
    }, errors.activeDays))), values.alertType != "clock-in-reminder" ? /*#__PURE__*/React.createElement("div", {
      className: "p-3 my-3 border create-alert-clock-in-reminder-report-recipients-notification-wrapper"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-success d-block create-alert-clock-in-reminder-report-recipients-notification-wrapper-text1"
    }, "Employees to Include in Report"), /*#__PURE__*/React.createElement("p", {
      className: "mb-2 text-success create-alert-clock-in-reminder-report-recipients-notification-wrapper-text2"
    }, values.alertType == "late-clock-in-email-alert" ? "Choose whether to include all late clock-ins or only selected employees in the email report." : values.alertType == "absence-email-alert" ? "Choose whether to include all absents or only selected employees in the email report." : values.alertType == "early-clock-out-email-alert" ? "Choose whether to include all clock-outs or only selected employees in the email report." : values.alertType == "high-idle-time" ? "Choose whether to include all idles or only selected employees in the email report." : null), /*#__PURE__*/React.createElement(Form.Group, {
      className: "create-alert-clock-in-reminder-employee-include-report-wrapper"
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: values.alertType == "late-clock-in-email-alert" ? "Include all late clock-ins" : values.alertType == "absence-email-alert" ? "Include all absents" : values.alertType == "early-clock-out-email-alert" ? "Include all early clock-outs" : "Include all high idle time records",
      value: "allEmployees",
      name: "userPreferenceType",
      id: "include-all-late-clock-ins",
      className: "create-new-alert-radion-button"
    }), " ", /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: values.alertType == "late-clock-in-email-alert" ? "Include selected employees' late clock-in only" : values.alertType == "absence-email-alert" ? "Include selected employees' absent only" : values.alertType == "early-clock-out-email-alert" ? "Include selected employees’ early clock-outs only" : "Include selected employees’ high idle time records only",
      value: "selectedEmployees",
      name: "userPreferenceType",
      id: "include-late-clock-ins-for-selected-employees-only",
      className: "create-new-alert-radion-button"
    })), values.userPreferenceType == "selectedEmployees" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "userPreferenceList"
    }, function (_ref23) {
      var field = _ref23.field,
        form = _ref23.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), userPreferenceListError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("userPreferenceList", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("userPreferenceList", []);
          }
        },
        options: userList,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "p-3 my-3 border create-alert-clock-in-reminder-notification-wrapper"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "text-success d-block create-alert-clock-in-reminder-notification-wrapper-text1"
    }, "Notification Recipients"), /*#__PURE__*/React.createElement("p", {
      className: "mb-2 text-success create-alert-clock-in-reminder-notification-wrapper-text2"
    }, "Choose who should receive these notifications"), /*#__PURE__*/React.createElement("div", {
      className: "create-alert-clock-in-reminder-notification-wrapper-text3"
    }, "Send ", values.alertType == "clock-in-reminder" ? "reminder" : "notification", " to:"), /*#__PURE__*/React.createElement(Form.Group, null, values.alertType == "clock-in-reminder" ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to everyone",
      value: "everyone",
      name: "sendReminderTo",
      id: "send-reminder-to-everyone",
      className: "create-new-alert-radion-button"
    }) : null, " ", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to team members only",
      value: "teamMembers",
      name: "sendReminderTo",
      id: "send-reminder-to-team-members-only",
      className: "create-new-alert-radion-button"
    }), /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to team members and team heads only",
      value: "teamMembers&teamHead",
      name: "sendReminderTo",
      id: "send-reminder-to-team-members-and-team-heads-only",
      className: "create-new-alert-radion-button"
    })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref24) {
      var field = _ref24.field,
        form = _ref24.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)) : values.alertType == "absence-email-alert" ? /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to admin(s)",
      value: "admin",
      name: "sendReminderTo",
      id: "send-to-admin",
      className: "create-new-alert-radion-button"
    }) : null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref25) {
      var field = _ref25.field,
        form = _ref25.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)) : /*#__PURE__*/React.createElement(React.Fragment, null, role != "Head" ? /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to admin(s)",
      value: "admin",
      name: "sendReminderTo",
      id: "send-to-admin",
      className: "create-new-alert-radion-button"
    }) : null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send to respective team members",
      value: "respectiveTeamMembers",
      name: "sendReminderTo",
      id: "send-to-respective-members",
      className: "create-new-alert-radion-button"
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      inline: true,
      type: "radio",
      label: "Send reminder to selective persons",
      value: "selectivePersons",
      name: "sendReminderTo",
      id: "send-reminder-to-selective-persons",
      className: "create-new-alert-radion-button"
    }), values.sendReminderTo == "selectivePersons" ? /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      sm: 12,
      className: "mpr-sm-4"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "alertSendTo"
    }, function (_ref26) {
      var field = _ref26.field,
        form = _ref26.form;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "payroll-settings-edit-label-name"
      }, "Select Members", /*#__PURE__*/React.createElement("span", {
        "class": "add-employee-modal-form-employee-label-name-required"
      }, " *")), alertSendToError, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
        value: userList.filter(function (option) {
          return field.value.includes(option.value);
        }),
        onChange: function onChange(selectedArray) {
          if (selectedArray) {
            setFieldValue("alertSendTo", selectedArray.map(function (item) {
              return item.value;
            }));
          } else {
            setFieldValue("alertSendTo", []);
          }
          // setFieldValue("alertSendTo", e.value);
        },
        options: userList
        //defaultMenuIsOpen={true}
        ,
        isMulti: true,
        menuPosition: "fixed",
        className: "payroll-setup-modal-dropdown",
        styles: {
          container: function container(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          },
          control: function control(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              width: "100%"
            });
          }
        }
      })));
    })) : null)))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Button, {
      variant: "dark",
      className: "create-alert-rule-button",
      type: "submit",
      disabled: editRealTimeAlertNotificationLoading || values.alertType == "clock-in-reminder" && values.sendEmailAt && moment(values.expectedClockInTime) < moment(values.sendEmailAt) || values.alertType != "clock-in-reminder" && values.sendEmailAt && moment(values.expectedClockInTime) > moment(values.sendEmailAt) || values.alertType == "high-idle-time" && values.startTime && values.endTime && moment(values.endTime) <= moment(values.startTime)
    }, editRealTimeAlertNotificationLoading ? "Loading..." : "Update Alert Rule")));
  })));
};
var DeleteAlertRuleModal = function DeleteAlertRuleModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    organisationId = props.organisationId,
    userId = props.userId,
    organisationSettings = props.organisationSettings;
  if (showDeleteModal === null) {
    return null;
  }
  var alertId = showDeleteModal.alertId;
  var _useMutation7 = useMutation(DELETE_REAL_TIME_ALERT_NOTIFICATION_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    deleteRealTimeAlertNotification = _useMutation8[0],
    deleteLoading = _useMutation8[1].loading;
  var handleDelete = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!deleteLoading) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.next = 4;
            return deleteRealTimeAlertNotification({
              variables: {
                organisationId: organisationId,
                alertId: alertId,
                userId: userId
              },
              update: function update(cache) {
                cache.modify({
                  fields: {
                    listRealTimeAlertNotification: function listRealTimeAlertNotification() {
                      var existing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                      return existing.filter(function (item) {
                        return item.alertId !== alertId;
                      });
                    }
                  }
                });
                cache.modify({
                  fields: {
                    alertRuleHeaderDetails: function alertRuleHeaderDetails(existing) {
                      return _objectSpread(_objectSpread({}, existing), {}, {
                        totalRuleCount: Math.max(((existing === null || existing === void 0 ? void 0 : existing.totalRuleCount) || 0) - 1, 0),
                        activeRuleCount: Math.max(((existing === null || existing === void 0 ? void 0 : existing.activeRuleCount) || 0) - 1, 0)
                      });
                    }
                  }
                });
              }
            });
          case 4:
            response = _context4.sent;
            if (!(!response || !response.data || response.data.deleteRealTimeAlertNotification === null)) {
              _context4.next = 10;
              break;
            }
            toast.error("Error Occured, Try again later!");
            throw new Error("error");
          case 10:
            handleDeleteClose();
            toast.success("Rule deleted successfully!");
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  }, [deleteRealTimeAlertNotification, deleteLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose,
    backdrop: "static" // disables outside click close
    ,
    keyboard: false
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Rule")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this rule?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "However you will be able to create a new rule like this again anytime."))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDelete(),
    disabled: deleteLoading ? true : false
  }, deleteLoading ? "Loading..." : "Delete")));
};
export default RealTimeNotification;